import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: number; output: number; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An arbitrary precision signed decimal */
  BigDecimal: { input: number; output: number; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string; }
  /** Local Date type */
  LocalDate: { input: any; output: any; }
  /** Local Date Time type */
  LocalDateTime: { input: string; output: string; }
  /** Local Time type */
  LocalTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: string; output: string; }
}

export interface AmountStatusDto {
  __typename?: 'AmountStatusDto';
  /** Сумма операций по статусу */
  amount: Scalars['BigDecimal']['output'];
  /** Кол-во платежей у статуса */
  count: Scalars['Long']['output'];
  /** Статус операции */
  statusCode: Status;
}

export interface BankInput {
  id: Scalars['ID']['input'];
}

export enum BankType {
  /** Все банки */
  All = 'ALL',
  /** Внешние банки */
  Foreign = 'FOREIGN',
  /** Нац банки */
  National = 'NATIONAL'
}

export interface Banks {
  __typename?: 'Banks';
  absBankCode: Maybe<Scalars['Int']['output']>;
  bankCode: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  corAccount: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  partyBankId: Maybe<Scalars['Long']['output']>;
}

export interface BudgetClassificationCode {
  __typename?: 'BudgetClassificationCode';
  classCode: Scalars['String']['output'];
  className: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
}

export interface BudgetClassificationCodeInput {
  id: Scalars['ID']['input'];
}

export interface BudgetPaymentInput {
  /** Валюта */
  currency: CurrencyInput;
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Счет списания */
  payerAccount: Scalars['String']['input'];
  /** Айди операции в ПЛ */
  paylogicId: Scalars['Long']['input'];
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Тип налога */
  taxType: Scalars['String']['input'];
  /** Номер документа */
  transferNum: Scalars['String']['input'];
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

export interface BudgetPaymentRecord {
  __typename?: 'BudgetPaymentRecord';
  /** Сумма платежа */
  amount: Scalars['BigDecimal']['output'];
  /** Комиссия */
  commission: Scalars['BigDecimal']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Код валюты */
  currency: Scalars['String']['output'];
  /** Причина отказа платежа(если есть) */
  description: Maybe<Scalars['String']['output']>;
  /** Айди бюджетного платежа */
  id: Scalars['Long']['output'];
  /** Айди юридического лица */
  legalPartyId: Scalars['Long']['output'];
  /** Код операции */
  operationCode: Operations;
  /** Счет плательщика */
  payerAccount: Scalars['String']['output'];
  /** Айди Paylogic */
  paylogicId: Scalars['Long']['output'];
  /** Код платежа */
  paymentCode: Scalars['String']['output'];
  /** Назначение платежа */
  purpose: Scalars['String']['output'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['output'];
  /** Статус платежа */
  statusCode: Status;
  /** Номер перевода */
  transferNum: Scalars['String']['output'];
  /** Идентификатор пользователя, обновившего запись */
  updatedBy: Scalars['String']['output'];
  /** Дата зачисления */
  valueDate: Scalars['Date']['output'];
}

export interface CalculateAmountConversionInput {
  /** Сумма для конверсии */
  amount: Scalars['BigDecimal']['input'];
  /** Операция конверсии по курсу */
  conversionExchangeRateOperation: ConversionExchangeRateOperation;
  /** Исходная валюта */
  currency: CurrencyInput;
  /** Фиксированный ли курс */
  isFixedRate: Scalars['Boolean']['input'];
  /** Курс конверсии */
  rate: Scalars['BigDecimal']['input'];
  /** Целевая валюта */
  targetCurrency: CurrencyInput;
}

export interface CalculateExoticAmountInput {
  /** Сумма в базовой валюте */
  amount: Scalars['BigDecimal']['input'];
  /** Курс экзотической валюты */
  rate: Scalars['BigDecimal']['input'];
}

export interface CardTransferInput {
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди счета списания */
  payerAccountId: Scalars['Long']['input'];
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Реквизиты получателя||Айди счёта пополнения */
  recipientDetail: Scalars['String']['input'];
  /** Номер документа */
  transferNum: InputMaybe<Scalars['String']['input']>;
}

export interface CardTransferRecord {
  __typename?: 'CardTransferRecord';
  /** Сумма перевода */
  amount: Scalars['BigDecimal']['output'];
  /** Идентификатор карточного шаблона */
  cardReferencesId: Maybe<Scalars['String']['output']>;
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Код валюты */
  currencyCode: Scalars['String']['output'];
  /** Айди валюты */
  currencyId: Scalars['Int']['output'];
  /** Причина отказа платежа(если есть) */
  description: Maybe<Scalars['String']['output']>;
  /** Айди перевода */
  id: Scalars['Long']['output'];
  /** Айди юридического лица */
  legalPartyId: Scalars['Long']['output'];
  /** Код операции */
  operationCode: Operations;
  /** Источник перевода */
  origin: Origin;
  /** Счет плательщика */
  payerAccount: Scalars['String']['output'];
  /** Имя плательщика */
  payerName: Scalars['String']['output'];
  /** Код платежа */
  paymentCode: Maybe<Scalars['String']['output']>;
  /** Назначение платежа */
  purpose: Scalars['String']['output'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['output'];
  /** БИК получателя */
  recipientBic: Scalars['String']['output'];
  /** Наименование банка получателя */
  recipientBicName: Scalars['String']['output'];
  /** Номер карты получателя */
  recipientCardNum: Maybe<Scalars['String']['output']>;
  /** Код валюты получателя */
  recipientCurrencyCode: Scalars['String']['output'];
  /** Дополнительные реквизиты получателя */
  recipientDetail: Scalars['String']['output'];
  /** ИНН получателя */
  recipientInn: Scalars['String']['output'];
  /** Имя получателя */
  recipientName: Scalars['String']['output'];
  /** Статус перевода */
  statusCode: Status;
  /** Номер перевода */
  transferNum: Scalars['String']['output'];
  /** Дата зачисления */
  valueDate: Scalars['Date']['output'];
}

/**  ------  INPUT --------------- */
export interface CommissionInput {
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Операция */
  operation: OperationInput;
  /** Айди счета списания */
  payerAccountId: Scalars['Long']['input'];
}

export enum CommissionOption {
  Ben = 'BEN',
  Gour = 'GOUR',
  Our = 'OUR',
  Sha = 'SHA'
}

/** ------TYPE------------------------- */
export interface CommissionResponse {
  __typename?: 'CommissionResponse';
  commissionAmount: Scalars['BigDecimal']['output'];
  totalAmount: Scalars['BigDecimal']['output'];
}

export enum Confirm {
  Confirm = 'CONFIRM',
  Revoke = 'REVOKE'
}

export enum ConversionExchangeRateOperation {
  Buy = 'BUY',
  CurrencyConversion = 'CURRENCY_CONVERSION',
  Sell = 'SELL'
}

export interface ConversionInput {
  /** Сумма в исходной валюте */
  amount: Scalars['BigDecimal']['input'];
  /** Исходная валюта */
  currency: CurrencyInput;
  /** ID подразделения */
  departmentId: Scalars['Int']['input'];
  /** Фиксированный курс */
  isFixedRate: Scalars['Boolean']['input'];
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Операция */
  operation: OperationInput;
  /** Счёт плательщика */
  payerAccount: Scalars['String']['input'];
  /** Банк плательщика (BIC) */
  payerBic: BankInput;
  /** Имя плательщика */
  payerName: Scalars['String']['input'];
  /** Курс конверсии */
  rate: Scalars['BigDecimal']['input'];
  /** Счёт получателя */
  recipientAccount: Scalars['String']['input'];
  /** Валюта счёта получателя */
  recipientAccountCurrency: CurrencyInput;
  /** Сумма в целевой валюте */
  recipientAmount: Scalars['BigDecimal']['input'];
  /** Номер перевода */
  transferNum: InputMaybe<Scalars['String']['input']>;
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

export interface ConversionPaymentRecord {
  __typename?: 'ConversionPaymentRecord';
  amount: Scalars['BigDecimal']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  creatorName: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  currencyId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isFixedRate: Scalars['Boolean']['output'];
  legalPartyId: Scalars['Long']['output'];
  operationCode: Operations;
  payerAccount: Scalars['String']['output'];
  payerBic: Scalars['String']['output'];
  payerBicName: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  rate: Scalars['BigDecimal']['output'];
  recipientAccount: Scalars['String']['output'];
  recipientAmount: Scalars['BigDecimal']['output'];
  recipientCurrencyCode: Scalars['String']['output'];
  recipientCurrencyId: Scalars['Int']['output'];
  statusCode: Status;
  transferNum: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  valueDate: Scalars['Date']['output'];
}

export interface Country {
  __typename?: 'Country';
  fullName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  numInList: Scalars['String']['output'];
}

export interface CountryInput {
  id: Scalars['ID']['input'];
}

export interface Currency {
  __typename?: 'Currency';
  id: Maybe<Scalars['Int']['output']>;
  isoCode: Scalars['String']['output'];
  isoName: Scalars['String']['output'];
  isoNum: Scalars['String']['output'];
}

export interface CurrencyInput {
  id: Scalars['ID']['input'];
}

export interface CurrencyRateDto {
  __typename?: 'CurrencyRateDto';
  code: Scalars['String']['output'];
  purchaseRate: Scalars['BigDecimal']['output'];
  salesRate: Scalars['BigDecimal']['output'];
}

export interface CurrencyRatesDto {
  __typename?: 'CurrencyRatesDto';
  card: Array<CurrencyRateDto>;
  cash: Array<CurrencyRateDto>;
  cashless: Array<CurrencyRateDto>;
  nbkr: Array<CurrencyRateDto>;
}

export interface DailyQrOperationCountAndAmount {
  __typename?: 'DailyQrOperationCountAndAmount';
  /** Кол-во операций */
  operationCount: Scalars['Int']['output'];
  /** Общая сумма операций */
  totalAmount: Scalars['BigDecimal']['output'];
}

export interface GroupOperation {
  __typename?: 'GroupOperation';
  groupCode: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  operationsById: Array<Operation>;
}

export interface GroupedPaymentInfo {
  __typename?: 'GroupedPaymentInfo';
  currencyCode: Scalars['String']['output'];
  operation: Operations;
  quantity: Scalars['Long']['output'];
  totalAmount: Scalars['BigDecimal']['output'];
}

export interface HistoryCountStatus {
  __typename?: 'HistoryCountStatus';
  count: Scalars['Long']['output'];
  statusCode: Status;
}

export interface HistoryPayment {
  __typename?: 'HistoryPayment';
  paymentInformation: OperationHistoryByCriteria;
  state: PaymentSubscriptionStateEnum;
}

export interface LegalPartyIdAndPaymentIdInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди платежа */
  paymentId: InputMaybe<Scalars['Long']['input']>;
}

export interface LegalPartyIdInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
}

export interface LegalPartyIdInvoiceIdDto {
  /** Айди счета на оплату */
  invoiceIds: Array<Scalars['Long']['input']>;
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Удалить платеж на черновике или изменении */
  deletePayment: RecordId;
  /** Удалить шаблон ЗП ведомости */
  deleteSalaryTemplate: Scalars['Boolean']['output'];
  /** Удалить шаблон */
  deleteTemplate: Scalars['Boolean']['output'];
  /** Платеж отправлен на подпись. */
  forSigningPayment: Array<RecordPayments>;
  /** Отозвать платёж (Только создатель платежа!) */
  recallPayment: Array<RecordPayments>;
  /** Возврат платежа */
  refundOperation: PaymentPcTransactionId;
  /** Сохранить Бюджетный Платёж. Сформирован(черновик). */
  saveBudgetPayment: PaymentPcTransactionId;
  /**  --------- Карточная операция ---------------------------------------------------------------------- */
  saveCardTransfer: PaymentPcTransactionId;
  /** Сохранить конвертацию. Сформирован(черновик). */
  saveConversionDraft: PaymentPcTransactionId;
  /** Сохранить межбанк сом. Сформирован(черновик). */
  saveInterBankTransferNativeDraft: PaymentPcTransactionId;
  /** Сохранить внутрибанк между чужими счетами. Сформирован(черновик). */
  saveIntraBankForeignTransferDraft: PaymentPcTransactionId;
  /** Сохранить внутрибанк междусвоими счетами. Сформирован(черновик). */
  saveIntraBankOwnerTransferDraft: PaymentPcTransactionId;
  /** Сохранить qr перевод(платеж). Сформирован(черновик). */
  saveQrTransfer: PaymentPcTransactionId;
  /** Сохранение ведомости */
  saveSalary: RecordId;
  /** Сохранить шаблон ЗП ведомости */
  saveSalaryTemplate: Scalars['Boolean']['output'];
  /** Сохранить Swift. Сформирован(черновик). */
  saveSwift: PaymentPcTransactionId;
  /** Сохранить шаблон */
  saveTransferTemplate: Scalars['Boolean']['output'];
  /** Отправка платежей в АБС */
  sendPayment2ABS: Array<RecordId>;
  /** Подписать платеж */
  signingPayment: Array<RecordPayments>;
  /** Подписать ведомость */
  signingSalary: RecordPayments;
  /** Обновить данные платежа */
  updatePayment: RecordId;
  /** Изменить шаблон ЗП ведомости */
  updateSalaryTemplate: Scalars['Boolean']['output'];
  /** Обновить шаблон */
  updateTemplate: Scalars['Boolean']['output'];
}


export interface MutationDeletePaymentArgs {
  payment: PaymentIdInput;
}


export interface MutationDeleteSalaryTemplateArgs {
  template: TemplateIdInput;
}


export interface MutationDeleteTemplateArgs {
  template: TemplateIdInput;
}


export interface MutationForSigningPaymentArgs {
  payment: PaymentIdListInput;
}


export interface MutationRecallPaymentArgs {
  paymentIdListInput: PaymentIdListInput;
}


export interface MutationRefundOperationArgs {
  refundInput: RefundInput;
}


export interface MutationSaveBudgetPaymentArgs {
  budgetPayment: BudgetPaymentInput;
}


export interface MutationSaveCardTransferArgs {
  cardTransfer: CardTransferInput;
}


export interface MutationSaveConversionDraftArgs {
  conversion: ConversionInput;
}


export interface MutationSaveInterBankTransferNativeDraftArgs {
  interBankTransfer: TransferInput;
}


export interface MutationSaveIntraBankForeignTransferDraftArgs {
  intraTransfer: TransferInput;
}


export interface MutationSaveIntraBankOwnerTransferDraftArgs {
  intraTransfer: TransferInput;
}


export interface MutationSaveQrTransferArgs {
  qrTransferInput: QrTransferInput;
}


export interface MutationSaveSalaryArgs {
  salaryRequest: SalaryRequest;
}


export interface MutationSaveSalaryTemplateArgs {
  template: SalaryTemplateInput;
}


export interface MutationSaveSwiftArgs {
  swift: SwiftInput;
}


export interface MutationSaveTransferTemplateArgs {
  template: TransferTemplateInput;
}


export interface MutationSendPayment2AbsArgs {
  payment: SendPayment2AbsInput;
}


export interface MutationSigningPaymentArgs {
  sign: SignatureInput;
}


export interface MutationSigningSalaryArgs {
  sign: SignatureSalaryInput;
}


export interface MutationUpdatePaymentArgs {
  updatePayment: UpdatePayment;
}


export interface MutationUpdateSalaryTemplateArgs {
  template: SalaryTemplateInput;
}


export interface MutationUpdateTemplateArgs {
  template: InputMaybe<TemplateInput>;
}

export interface Operation {
  __typename?: 'Operation';
  groupOperationByGroupId: GroupOperation;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  operationCode: Scalars['String']['output'];
  operationName: Scalars['String']['output'];
}

export interface OperationHistoryByCriteria {
  __typename?: 'OperationHistoryByCriteria';
  /** Сумма операции */
  amount: Scalars['BigDecimal']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Код валюты */
  currency: Scalars['String']['output'];
  /** Причина отказа платежа(если есть) */
  description: Scalars['String']['output'];
  /** Айди операции */
  id: Scalars['Long']['output'];
  /** Айди юридического лица */
  legalPartyId: Scalars['Long']['output'];
  /** Код операции */
  operationCode: Operations;
  /** Источник создания */
  origin: Origin;
  /** Счет плательщика */
  payerAccount: Scalars['String']['output'];
  /** Айди платежных реквизитов */
  paymentDetailsId: Scalars['Long']['output'];
  /** Назначение платежа */
  purpose: Scalars['String']['output'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['output'];
  /** Бик получателя */
  recipientBic: Maybe<Scalars['String']['output']>;
  /** Имя получателя */
  recipientName: Scalars['String']['output'];
  /** Статус операции */
  statusCode: Status;
  /** Номер перевода */
  transferNum: Scalars['String']['output'];
  /** Идентификатор обновившего */
  updatedBy: Scalars['String']['output'];
  /** Дата зачисления */
  valueDate: Scalars['Date']['output'];
}

export interface OperationInput {
  id: Scalars['ID']['input'];
}

export interface OperationTypeCategory {
  __typename?: 'OperationTypeCategory';
  categoryCode: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
}

export interface OperationTypeCategoryInput {
  id: Scalars['ID']['input'];
}

export enum OperationTypeGroup {
  /** QR на накладной */
  Consignment = 'CONSIGNMENT',
  /** Deeplink QR */
  DeeplinkQr = 'DEEPLINK_QR',
  /** Динамические QR */
  Dynamic = 'DYNAMIC',
  /** Счет на оплату */
  Invoice = 'INVOICE',
  /** QR на монитор */
  Monitor = 'MONITOR',
  /** Персональный QR с ВЕБ */
  PersonalQrWeb = 'PERSONAL_QR_WEB',
  /** Статичные QR */
  Static = 'STATIC',
  /** QR на сайт */
  Web = 'WEB'
}

export enum Operations {
  /** Бюджетный платеж */
  BudgetPayment = 'BUDGET_PAYMENT',
  /** Перевод с бизнес-карты на РКО (чужая) */
  BusinessCard_2RkoForeign = 'BUSINESS_CARD_2_RKO_FOREIGN',
  /** Перевод с бизнес-карты на РКО (собственная) */
  BusinessCard_2RkoOwn = 'BUSINESS_CARD_2_RKO_OWN',
  /** Клиринговая операция */
  Clearing = 'CLEARING',
  /** Конвертация валюты */
  Conversion = 'CONVERSION',
  /** Гроссовая операция */
  Gross = 'GROSS',
  /** Внутрибанковский перевод на чужой счет */
  IntrabankTransferForeign = 'INTRABANK_TRANSFER_FOREIGN',
  /** Внутрибанковский перевод на собственный счет */
  IntrabankTransferOwn = 'INTRABANK_TRANSFER_OWN',
  /** Перевод(платеж) по QR */
  Qr = 'QR',
  /** Возврат платежа */
  Refund = 'REFUND',
  /** Расход по РКО на бизнес-карту (чужая) */
  Rko_2BusinessCardForeign = 'RKO_2_BUSINESS_CARD_FOREIGN',
  /** Расход по РКО на бизнес-карту (собственная) */
  Rko_2BusinessCardOwn = 'RKO_2_BUSINESS_CARD_OWN',
  /** Расход по РКО на карту физического лица (чужая) */
  Rko_2IndividualCardForeign = 'RKO_2_INDIVIDUAL_CARD_FOREIGN',
  /** Расход по РКО на карту физического лица (собственная) */
  Rko_2IndividualCardOwn = 'RKO_2_INDIVIDUAL_CARD_OWN',
  /** SWIFT перевод */
  Swift = 'SWIFT',
  /** Внутрибанковский перевод по счету на оплату */
  TransferByInvoice = 'TRANSFER_BY_INVOICE'
}

export enum Origin {
  DirectBank = 'DIRECT_BANK',
  File = 'FILE',
  Manual = 'MANUAL'
}

export interface PcTransactionPaymentRecord {
  __typename?: 'PCTransactionPaymentRecord';
  id: Scalars['Long']['output'];
  pcTransactionId: Maybe<Scalars['String']['output']>;
}

export interface PageInput {
  amountElements: Scalars['Int']['input'];
  currentPage: Scalars['Int']['input'];
}

export interface PaginatedBank {
  __typename?: 'PaginatedBank';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  list: Array<Banks>;
}

export interface PaginatedBudgetClassificationCode {
  __typename?: 'PaginatedBudgetClassificationCode';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  list: Array<BudgetClassificationCode>;
}

export interface PaginatedOperationHistoryByCriteria {
  __typename?: 'PaginatedOperationHistoryByCriteria';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  currentPage: Scalars['Long']['output'];
  list: Array<OperationHistoryByCriteria>;
}

export interface PaginatedOperationTypeCategory {
  __typename?: 'PaginatedOperationTypeCategory';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  list: Array<OperationTypeCategory>;
}

export interface PaginatedQrOperationInfo {
  __typename?: 'PaginatedQrOperationInfo';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  currentPage: Scalars['Long']['output'];
  list: Array<QrOperationInfo>;
}

export interface PaginatedQrTransferRecordsByFilter {
  __typename?: 'PaginatedQrTransferRecordsByFilter';
  /** Кол-во элементов */
  amountElements: Scalars['Long']['output'];
  /** Кол-во страниц пагинации */
  amountPages: Scalars['Long']['output'];
  /** Текущая страница */
  currentPage: Scalars['Long']['output'];
  /** Список qr платежей */
  list: Array<QrTransferRecordByFilter>;
}

export interface PaginatedSalary {
  __typename?: 'PaginatedSalary';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  list: Array<SalaryRecord>;
}

export interface PaginatedSalaryDetail {
  __typename?: 'PaginatedSalaryDetail';
  amountElements: Scalars['Long']['output'];
  amountPages: Scalars['Long']['output'];
  list: Array<SalaryDetailResponse>;
}

export interface PaginatedTransferByInvoiceDto {
  __typename?: 'PaginatedTransferByInvoiceDto';
  /** Кол-во элементов */
  amountElements: Scalars['Long']['output'];
  /** Кол-во страниц пагинации */
  amountPages: Scalars['Long']['output'];
  /** Текущая страница */
  currentPage: Scalars['Long']['output'];
  /** Список платежей */
  list: Array<TransferByInvoiceDto>;
}

export interface PaymentIdInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди платежа */
  paymentId: Scalars['Long']['input'];
}

export interface PaymentIdListInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди платежей */
  paymentIds: Array<InputMaybe<Scalars['Long']['input']>>;
}

export interface PaymentPcTransactionId {
  __typename?: 'PaymentPcTransactionId';
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Айди подписи, если создано */
  pcTransactionId: Maybe<Scalars['String']['output']>;
}

export enum PaymentStatus {
  Error = 'ERROR',
  Successful = 'SUCCESSFUL'
}

export interface PaymentStatusHistory {
  __typename?: 'PaymentStatusHistory';
  id: Scalars['Long']['output'];
  statusCode: Status;
  updatedBy: Scalars['String']['output'];
  updatedDate: Scalars['LocalDateTime']['output'];
}

export enum PaymentSubscriptionStateEnum {
  Deleted = 'DELETED',
  New = 'NEW',
  Updated = 'UPDATED'
}

export interface PersonalQrOperationFilterInput {
  /** Сортировка по сумме убывание/возрастание */
  amountAsc: InputMaybe<Scalars['Boolean']['input']>;
  /** Сумма до */
  endAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата до */
  endDate: Scalars['Date']['input'];
  /** Время до */
  endTime: InputMaybe<Scalars['String']['input']>;
  /** Айди компании */
  legalPartyId: Scalars['Long']['input'];
  /** Айди сгенерированного QR */
  qrTransactionId: Scalars['String']['input'];
  /** Номер чека */
  stan: InputMaybe<Scalars['String']['input']>;
  /** Сумма от */
  startAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата от */
  startDate: Scalars['Date']['input'];
  /** Время от */
  startTime: InputMaybe<Scalars['String']['input']>;
}

export interface QrDetailResponse {
  __typename?: 'QrDetailResponse';
  /** Можно ли менять сумму */
  allowEditSum: Maybe<Scalars['Boolean']['output']>;
  /** Сумма операции */
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** Сумма зашитая в QR */
  amountAsBigDecimal: Maybe<Scalars['BigDecimal']['output']>;
  /** Уникальный идентификатор плательщика в пределах услуги в ИС поставщика услуг */
  qrAccount: Maybe<Scalars['String']['output']>;
  /** Валюта зашитая в QR, работаем только с 417(сом) */
  qrCcy: Scalars['String']['output'];
  /** Комент зашитый в QR */
  qrComment: Maybe<Scalars['String']['output']>;
  /** Хеш сумма всей QR структуры */
  qrControlSum: Scalars['String']['output'];
  /** MCC код поставщика услуг */
  qrMcc: Scalars['Int']['output'];
  /** ID мерчанта */
  qrMerchantId: Maybe<Scalars['String']['output']>;
  /** Поставщик услуг */
  qrMerchantProvider: Scalars['String']['output'];
  /** Код услуги в платежном шлюзе */
  qrServiceId: Maybe<Scalars['String']['output']>;
  /** Идентификатор транзакции в ИС поставщика */
  qrTransactionId: Maybe<Scalars['String']['output']>;
  /** Зашито - тип QR (STATIC, DYNAMIC) */
  qrType: Scalars['String']['output'];
  /** Зашито в qr - версия qr */
  qrVersion: Scalars['String']['output'];
  /** Unknown */
  salePointQr: Maybe<Scalars['String']['output']>;
}

export interface QrInfoResponse {
  __typename?: 'QrInfoResponse';
  /** Межбанк или внутрибанк перевод */
  direction: QrTransferDirection;
  /** Модель взаимодействия компании(отправителя) и клиента(получателя) */
  elqrTransferType: QrTransferType;
  /** Информация с qr */
  qrDetails: QrDetailResponse;
  /** Счёт получателя */
  recipientAccount: Scalars['String']['output'];
  /** Наименование получателя */
  recipientName: Scalars['String']['output'];
}

export interface QrOperationFilterInput {
  /** Карточный счет */
  accounts: Array<Scalars['String']['input']>;
  /** Сортировка по сумме убывание/возростание */
  amountAsc: InputMaybe<Scalars['Boolean']['input']>;
  /** Сумма до */
  endAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата до */
  endDate: InputMaybe<Scalars['Date']['input']>;
  /** Время до */
  endTime: InputMaybe<Scalars['String']['input']>;
  /** Иденфикатор - qr операции ТОЛЬКО по торговым точкам или нет */
  isOnlySalePointOperations: InputMaybe<Scalars['Boolean']['input']>;
  legalPartyId: Scalars['Long']['input'];
  /** Тип QR */
  operationTypeGroup: InputMaybe<OperationTypeGroup>;
  /** Номер POS-терминала */
  qrAccount: InputMaybe<Scalars['String']['input']>;
  /** Список кодов торговой точки */
  salePointCodeList: Array<Scalars['Long']['input']>;
  /** Номер чека */
  stan: InputMaybe<Scalars['String']['input']>;
  /** Сумма от */
  startAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата от */
  startDate: InputMaybe<Scalars['Date']['input']>;
  /** Время от */
  startTime: InputMaybe<Scalars['String']['input']>;
}

export interface QrOperationFilterWithSalePoint {
  /** Расчётный счет */
  accounts: Array<Scalars['String']['input']>;
  /** Сортировка по сумме убывание/возростание */
  amountAsc: InputMaybe<Scalars['Boolean']['input']>;
  /** Коды касс */
  cashCodes: Array<Scalars['Long']['input']>;
  /** Сумма до */
  endAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата до */
  endDate: Scalars['Date']['input'];
  /** Время до */
  endTime: InputMaybe<Scalars['String']['input']>;
  /** Айди компании */
  legalPartyId: Scalars['Long']['input'];
  /** Тип QR */
  operationTypeGroup: InputMaybe<OperationTypeGroup>;
  /** Код точки */
  salePointCode: Scalars['Long']['input'];
  /** Номер чека */
  stan: InputMaybe<Scalars['String']['input']>;
  /** Сумма от */
  startAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата от */
  startDate: Scalars['Date']['input'];
  /** Время от */
  startTime: InputMaybe<Scalars['String']['input']>;
}

export interface QrOperationInfo {
  __typename?: 'QrOperationInfo';
  /** Счет */
  account: Scalars['String']['output'];
  /** Сумма операции c комиссией */
  amountWithFee: Scalars['BigDecimal']['output'];
  /** Сумма после вычета комиссии */
  amountWithoutFee: Scalars['BigDecimal']['output'];
  /** Код кассы */
  cashCode: Maybe<Scalars['String']['output']>;
  /** Дата создания */
  createdDate: Scalars['Date']['output'];
  /** Время создания */
  createdTime: Scalars['LocalTime']['output'];
  /** Назначение */
  description: Maybe<Scalars['String']['output']>;
  /** Сумма комиссии */
  feeAmount: Scalars['BigDecimal']['output'];
  /** Процент комиссии */
  feePercent: Scalars['BigDecimal']['output'];
  /** Уник. идентификатор */
  id: Scalars['String']['output'];
  /** Тип операции */
  operationType: Maybe<Scalars['String']['output']>;
  /** Тип QR */
  operationTypeGroup: Maybe<OperationTypeGroup>;
  /** Источник */
  origin: Scalars['String']['output'];
  /** Номер квитанции */
  providerTransactionId: Maybe<Scalars['String']['output']>;
  /** Номер POS-терминала */
  qrAccount: Scalars['String']['output'];
  /** Комментарий */
  qrComment: Maybe<Scalars['String']['output']>;
  /** Статус операции */
  qrOperationStatus: Maybe<Scalars['String']['output']>;
  /** Имя получателя */
  recipientName: Maybe<Scalars['String']['output']>;
  /** Имя торговой точки */
  salePointName: Maybe<Scalars['String']['output']>;
  /** Имя отправителя */
  senderName: Maybe<Scalars['String']['output']>;
  /** Номер чека */
  stan: Scalars['String']['output'];
}

export interface QrOperationInstallmentFilterInput {
  /** Сумма до */
  endAmount: Scalars['BigDecimal']['input'];
  /** Дата до */
  endDate: Scalars['Date']['input'];
  /** Id компании */
  legalPartyId: Scalars['Long']['input'];
  /** Статус операции */
  qrOperationStatus: Array<QrOperationStatus>;
  /** Тип операции */
  qrOperationType: Array<QrOperationType>;
  /** Код торговой точки */
  salePointCode: InputMaybe<Scalars['Long']['input']>;
  /** Сумма от */
  startAmount: Scalars['BigDecimal']['input'];
  /** Дата от */
  startDate: Scalars['Date']['input'];
}

export interface QrOperationLast2DaysFilter {
  /** Расчётный счет */
  accounts: Array<Scalars['String']['input']>;
  /** Коды касс */
  cashCodes: Array<Scalars['Int']['input']>;
  /** Айди компании */
  legalPartyId: Scalars['Long']['input'];
  /** Код точки */
  salePointCode: Scalars['Int']['input'];
}

export enum QrOperationStatus {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  Error = 'ERROR',
  InProcess = 'IN_PROCESS',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED'
}

export enum QrOperationType {
  AstrasendIncoming = 'ASTRASEND_INCOMING',
  Clearing = 'CLEARING',
  CollabElqrIncoming = 'COLLAB_ELQR_INCOMING',
  CollabPayment = 'COLLAB_PAYMENT',
  Commission = 'COMMISSION',
  Conversion = 'CONVERSION',
  Elqr = 'ELQR',
  ElqrIncoming = 'ELQR_INCOMING',
  ElqrIncomingPos = 'ELQR_INCOMING_POS',
  ExtraBankElcart = 'EXTRA_BANK_ELCART',
  ExtraBankVisa = 'EXTRA_BANK_VISA',
  Gross = 'GROSS',
  Payda = 'PAYDA',
  PaydaCollab = 'PAYDA_COLLAB',
  PaydaPos = 'PAYDA_POS',
  Payment = 'PAYMENT',
  PaymentPosTerminal = 'PAYMENT_POS_TERMINAL',
  Refund = 'REFUND',
  Saparpay = 'SAPARPAY',
  Swift = 'SWIFT',
  Transfer = 'TRANSFER'
}

export interface QrRefundRecord {
  __typename?: 'QrRefundRecord';
  /** Сумма платежа */
  amount: Scalars['BigDecimal']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Код валюты */
  currencyCode: Scalars['String']['output'];
  /** Причина отказа платежа(если есть) */
  description: Maybe<Scalars['String']['output']>;
  /** Айди перевода */
  id: Scalars['Long']['output'];
  /** Код операции */
  operationCode: Operations;
  /** Счет плательщика */
  payerAccount: Scalars['String']['output'];
  /** Имя плательщика */
  payerName: Scalars['String']['output'];
  /** Назначение платежа */
  purpose: Scalars['String']['output'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['output'];
  /** БИК получателя */
  recipientBic: Scalars['String']['output'];
  /** Наименование банка получателя */
  recipientBicName: Scalars['String']['output'];
  /** Номер карты получателя */
  recipientCardNum: Maybe<Scalars['String']['output']>;
  /** Дополнительные реквизиты получателя */
  recipientDetail: Scalars['String']['output'];
  /** Имя получателя */
  recipientName: Scalars['String']['output'];
  /** Статус платежа */
  statusCode: Status;
}

export interface QrRefundedOperationInfo {
  __typename?: 'QrRefundedOperationInfo';
  /** Информация о возвратном платеже */
  cardTransferRko2CardRecord: QrRefundRecord;
  /** Инфо о торговой точке(Если возврат был по торговой точке) */
  salePointDto: Maybe<SalePointDto>;
}

export enum QrTransferDirection {
  /** Получатель клиент другого банка */
  Foreign = 'FOREIGN',
  /** Получатель клиент оптимы */
  Intra = 'INTRA'
}

export interface QrTransferFilterInput {
  /** Счета списания */
  accounts: Array<Scalars['String']['input']>;
  /** Сортировка по сумме убывание/возрастание */
  amountAsc: InputMaybe<Scalars['Boolean']['input']>;
  /** Межбанк или внутрибанк перевод */
  elqrTransferDirection: InputMaybe<QrTransferDirection>;
  /** Тип qr перевода */
  elqrTransferType: InputMaybe<QrTransferType>;
  /** Сумма до */
  endAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата до */
  endDate: InputMaybe<Scalars['Date']['input']>;
  /** Время до */
  endTime: InputMaybe<Scalars['String']['input']>;
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Сумма от */
  startAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Дата от */
  startDate: InputMaybe<Scalars['Date']['input']>;
  /** Время от */
  startTime: InputMaybe<Scalars['String']['input']>;
  /** Номер перевода */
  transferNum: InputMaybe<Scalars['String']['input']>;
}

export interface QrTransferInput {
  /** Сумма операции, если сумма вшитая в QR больше нуля, то кидать по дефолту 0.00, иначе сумму введенный юзером */
  amount: Scalars['BigDecimal']['input'];
  /** Айди счета на оплату, передается только в случае операции оплата по счету на оплату */
  invoiceId: InputMaybe<Scalars['Long']['input']>;
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди счета списания */
  payerAccountId: Scalars['Long']['input'];
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Link с QR, передается только в случае QR операции */
  qrUrl: InputMaybe<Scalars['String']['input']>;
  /** Дата валютирования, передается только в случае операции оплата по счету на оплату */
  valueDate: InputMaybe<Scalars['LocalDate']['input']>;
}

export interface QrTransferRecordByFilter {
  __typename?: 'QrTransferRecordByFilter';
  /** Сумма платежа */
  amount: Scalars['BigDecimal']['output'];
  /** Комиссия */
  commission: Scalars['BigDecimal']['output'];
  /** Комиссия в процентах */
  commissionPercent: Scalars['BigDecimal']['output'];
  /** Дата и время создания записи */
  createdDateTime: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Maybe<Scalars['String']['output']>;
  /** Код валюты */
  currencyCode: Scalars['String']['output'];
  /** Тип qr перевода */
  elqrTransferType: QrTransferType;
  /** Счет списания */
  payerAccount: Scalars['String']['output'];
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Назначение платежа */
  purpose: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор плательщика в пределах услуги в ИС поставщика услуг */
  qrAccount: Maybe<Scalars['String']['output']>;
  /** Межбанк или внутрибанк перевод */
  qrTransferDirection: QrTransferDirection;
  /** Наименование получателя */
  recipientName: Maybe<Scalars['String']['output']>;
  /** Статус платежа */
  status: Status;
  /** Номер перевода */
  transferNum: Scalars['String']['output'];
}

export interface QrTransferRecordById {
  __typename?: 'QrTransferRecordById';
  /** Сумма платежа */
  amount: Scalars['BigDecimal']['output'];
  /** Комиссия */
  commission: Scalars['BigDecimal']['output'];
  /** Комиссия в процентах */
  commissionPercent: Scalars['BigDecimal']['output'];
  /** Дата и время создания записи */
  createdDateTime: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Код валюты */
  currencyCode: Scalars['String']['output'];
  /** Причина отказа платежа(если есть) */
  description: Maybe<Scalars['String']['output']>;
  /** Айди организации */
  legalPartyId: Scalars['Long']['output'];
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Назначение платежа */
  purpose: Maybe<Scalars['String']['output']>;
  /** Наименование получателя */
  recipientName: Scalars['String']['output'];
  /** Статус платежа */
  statusCode: Status;
  /** Номер перевода */
  transferNum: Scalars['String']['output'];
}

export enum QrTransferType {
  /** С юр. лица в сторону юр. лица */
  B2B = 'B2B',
  /** С юр. лица в сторону физ. лица */
  B2C = 'B2C',
  /** С юр. лица в сторону государство */
  B2G = 'B2G'
}

export interface Query {
  __typename?: 'Query';
  /** Расчет суммы для конвертации */
  calculateAmountInConversion: Scalars['BigDecimal']['output'];
  /** Расчёт комиссии */
  calculateCommission: CommissionResponse;
  /** Расчет суммы для экзотики. Расчет всегда проводиться в EUR. */
  calculateExoticAmountInSwift: Scalars['BigDecimal']['output'];
  /** Возможен ли возврат по определенному qr платежу */
  checkIsRefundAvailable: Scalars['Boolean']['output'];
  /** Список валют */
  findAllCurrency: Array<Currency>;
  /** Поиск QR переводов(платежей) по фильтрам */
  findAllQrTransferByFilter: PaginatedQrTransferRecordsByFilter;
  /** Список Банков фильтруемые по коду */
  findBankByCodeCriteria: PaginatedBank;
  /** Код назначения платежа (КБК) по коду и наименованию */
  findBudgetClassificationByCodeCriteria: PaginatedBudgetClassificationCode;
  /** Поиск платежа по ид (бюджетный платёж) */
  findBudgetPaymentDataByPaymentId: BudgetPaymentRecord;
  /** Поиск карточной операции по ид */
  findCardTransferDataByPaymentId: CardTransferRecord;
  /** Поиск платежа по ид (конвертация) */
  findConversionDataByPaymentId: ConversionPaymentRecord;
  /** Вид операции для ПБ Банка по коду */
  findOperationTypeCategoryByCodeCriteria: PaginatedOperationTypeCategory;
  /** Поиск всех TransferByInvoice платежей по списку счетов на оплату */
  findPaymentsByInvoiceIds: PaginatedTransferByInvoiceDto;
  /** Поиск QR перевода(платежа) по ид */
  findQrTransferDataByPaymentId: QrTransferRecordById;
  /** Получение информации по возвращенной qr операции */
  findRefundedQrOperationInfo: QrRefundedOperationInfo;
  /** Получение список ведомостей */
  findSalaryDataByLegalPartyId: PaginatedSalary;
  /** Получение деталей ведомости */
  findSalaryDetailBySalaryId: SalaryInfoWithDetail;
  /** Поиск платежа по ид (swift) */
  findSwiftDataByPaymentId: SwiftPaymentRecord;
  /** Поиск TransferByInvoice перевода(платежа) по ид */
  findTransferByInvoiceDetailById: TransferByInvoiceDetailDto;
  /** Поиск платежа по ид (клиринг, внутрибанк) */
  findTransferDataByPaymentId: TransferPaymentRecord;
  /** Список стран */
  getAllCountry: Array<Country>;
  /** Операции */
  getAllOperation: Array<Operation>;
  /** Счетчик платежей по статусам */
  getCountsOfPaymentsGroupedByStatus: Array<HistoryCountStatus>;
  /** Получить курсы валют */
  getCurrencyRates: CurrencyRatesDto;
  /** Группа операций */
  getGroupOperation: Array<GroupOperation>;
  /** Количество и информация операций по статусам и валютам */
  getGroupedPaymentsByFilter: Array<GroupedPaymentInfo>;
  /** Получить статусы и суммы платежей у счета на оплату */
  getInvoiceStatusAmounts: Array<AmountStatusDto>;
  /** Получение последней успешной для повтора ведомости */
  getLastSalaryForRepeat: SalaryContentData;
  /** Получения модели */
  getModelProcess: Maybe<Scalars['String']['output']>;
  /** Количество документов в статусе "На подпись" для текущего пользователя */
  getNumberOfPayment4Sign: Scalars['Int']['output'];
  /** Получения pcTransactionId из pay-control */
  getPCTransactionIDByPaymentFromPayControl: PcTransactionPaymentRecord;
  /** Получение детали QR */
  getParsedQRDetails: QrInfoResponse;
  /** Информация о подписанте платежа */
  getPaymentSignerInfoByPaymentId: Array<PaymentStatusHistory>;
  /** История статусов платежа по ID */
  getPaymentStatusHistoryByPaymentId: Array<PaymentStatusHistory>;
  /** Получение истории операций по персональному QR */
  getPersonalQrOperationHistoryWithPagination: PaginatedQrOperationInfo;
  /** Получение истории платежей по QR */
  getQrOperationHistory: PaginatedQrOperationInfo;
  /**
   * Получение истории операций по QR для Торговой точки / Кассы
   * @deprecated Field no longer supported
   */
  getQrOperationHistoryByFilterWithSalePoint: PaginatedQrOperationInfo;
  /** Получение транзакций по фильтру для Installment */
  getQrOperationInstallment: PaginatedQrOperationInfo;
  /** Получение Кол-во транзакций и общую сумму за последние 2 дня(сегодня, вчера) */
  getQrOperationsLast2Days: SaleQrOperationInfoLast2DaysDto;
  /** Получение шаблона ЗП ведомости пользователя */
  getSalaryTemplatesByCriteria: Array<SalaryTemplate>;
  getSecondPersonTokenByPaymentIds: Array<RecordTokens>;
  /** Сумма транзакций за период */
  getTotalSumInstallment: Scalars['BigDecimal']['output'];
  /** Шаблоны */
  getTransferTemplateByCriteria: Array<TransferTemplates>;
  /** История платежей по критериям */
  searchPaymentByCriteria: PaginatedOperationHistoryByCriteria;
}


export interface QueryCalculateAmountInConversionArgs {
  calculateAmount: CalculateAmountConversionInput;
}


export interface QueryCalculateCommissionArgs {
  commissionInput: CommissionInput;
}


export interface QueryCalculateExoticAmountInSwiftArgs {
  calculateAmount: CalculateExoticAmountInput;
}


export interface QueryCheckIsRefundAvailableArgs {
  refundIsAvailableInput: RefundIsAvailableInput;
}


export interface QueryFindAllQrTransferByFilterArgs {
  pageable: PageInput;
  qrTransferFilter: QrTransferFilterInput;
}


export interface QueryFindBankByCodeCriteriaArgs {
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankType: BankType;
  pageable: PageInput;
}


export interface QueryFindBudgetClassificationByCodeCriteriaArgs {
  budgetClassificationCode: InputMaybe<Scalars['String']['input']>;
  pageable: PageInput;
}


export interface QueryFindBudgetPaymentDataByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryFindCardTransferDataByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryFindConversionDataByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryFindOperationTypeCategoryByCodeCriteriaArgs {
  operationTypeCode: InputMaybe<Scalars['String']['input']>;
  pageable: PageInput;
}


export interface QueryFindPaymentsByInvoiceIdsArgs {
  legalPartyIdInvoiceId: LegalPartyIdInvoiceIdDto;
  pageable: PageInput;
}


export interface QueryFindQrTransferDataByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryFindRefundedQrOperationInfoArgs {
  payment: PaymentIdInput;
}


export interface QueryFindSalaryDataByLegalPartyIdArgs {
  pageable: PageInput;
  searchSalary: SearchSalary;
}


export interface QueryFindSalaryDetailBySalaryIdArgs {
  pageable: PageInput;
  salaryId: SalaryIdInput;
}


export interface QueryFindSwiftDataByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryFindTransferByInvoiceDetailByIdArgs {
  paymentIdInput: PaymentIdInput;
}


export interface QueryFindTransferDataByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryGetCountsOfPaymentsGroupedByStatusArgs {
  searchOperationHistory: SearchOperationHistoryInput;
}


export interface QueryGetGroupedPaymentsByFilterArgs {
  filterData: InputMaybe<SearchOperationHistoryInput>;
}


export interface QueryGetInvoiceStatusAmountsArgs {
  legalPartyIdInvoiceId: LegalPartyIdInvoiceIdDto;
}


export interface QueryGetLastSalaryForRepeatArgs {
  legalPartyId: LegalPartyIdInput;
}


export interface QueryGetModelProcessArgs {
  payment: PaymentIdInput;
}


export interface QueryGetNumberOfPayment4SignArgs {
  legalPartyIdInput: LegalPartyIdInput;
}


export interface QueryGetPcTransactionIdByPaymentFromPayControlArgs {
  payment: PaymentIdInput;
}


export interface QueryGetParsedQrDetailsArgs {
  legalPartyId: LegalPartyIdInput;
  qrUrl: Scalars['String']['input'];
}


export interface QueryGetPaymentSignerInfoByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryGetPaymentStatusHistoryByPaymentIdArgs {
  payment: PaymentIdInput;
}


export interface QueryGetPersonalQrOperationHistoryWithPaginationArgs {
  pageable: PageInput;
  personalQrOperationFilterInput: PersonalQrOperationFilterInput;
}


export interface QueryGetQrOperationHistoryArgs {
  pageable: PageInput;
  qrOperationFilterInput: QrOperationFilterInput;
}


export interface QueryGetQrOperationHistoryByFilterWithSalePointArgs {
  pageable: PageInput;
  qrOperationFilterInput: QrOperationFilterWithSalePoint;
}


export interface QueryGetQrOperationInstallmentArgs {
  filter: QrOperationInstallmentFilterInput;
  pageable: PageInput;
}


export interface QueryGetQrOperationsLast2DaysArgs {
  filter: QrOperationLast2DaysFilter;
}


export interface QueryGetSalaryTemplatesByCriteriaArgs {
  salaryTemplateCriteriaInput: SalaryTemplateCriteriaInput;
}


export interface QueryGetSecondPersonTokenByPaymentIdsArgs {
  payments: PaymentIdListInput;
}


export interface QueryGetTotalSumInstallmentArgs {
  filter: QrOperationInstallmentFilterInput;
}


export interface QueryGetTransferTemplateByCriteriaArgs {
  transferTemplateCriteria: TransferTemplateCriteriaInput;
}


export interface QuerySearchPaymentByCriteriaArgs {
  pageable: PageInput;
  searchOperationHistory: SearchOperationHistoryInput;
}

export interface RecordId {
  __typename?: 'RecordId';
  id: Scalars['Long']['output'];
}

export interface RecordPayments {
  __typename?: 'RecordPayments';
  id: Scalars['Long']['output'];
  status: PaymentStatus;
}

export interface RecordTokens {
  __typename?: 'RecordTokens';
  id: Scalars['Long']['output'];
  token: Scalars['String']['output'];
}

export interface RefundInput {
  /** Сумма возврата */
  amount: Scalars['BigDecimal']['input'];
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** Айди компании */
  legalPartyId: Scalars['Long']['input'];
  /** Назначение платежа */
  purpose: InputMaybe<Scalars['String']['input']>;
  /** Айди операции */
  transactionId: Scalars['String']['input'];
}

export interface RefundIsAvailableInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Доп данные получателя */
  recipientDetail: Scalars['String']['input'];
}

export interface SalaryContentData {
  __typename?: 'SalaryContentData';
  account: Scalars['String']['output'];
  amount: Scalars['BigDecimal']['output'];
  commission: Scalars['BigDecimal']['output'];
  companyName: Scalars['String']['output'];
  currency: Currency;
  legalPartyId: Scalars['Long']['output'];
  salaryDetails: Array<SalaryDetailData>;
  totalAmount: Scalars['BigDecimal']['output'];
  valueDate: Scalars['Date']['output'];
}

export interface SalaryContentInput {
  salaryDetails: Array<SalaryDetailInput>;
}

export interface SalaryDetailData {
  __typename?: 'SalaryDetailData';
  amount: Scalars['BigDecimal']['output'];
  cardAccount: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
}

export interface SalaryDetailInput {
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Карточный счет */
  cardAccount: Scalars['String']['input'];
  /** Полное имя */
  fullName: Scalars['String']['input'];
}

export interface SalaryDetailResponse {
  __typename?: 'SalaryDetailResponse';
  amount: Scalars['BigDecimal']['output'];
  cardAccount: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  state: Maybe<Scalars['Boolean']['output']>;
}

export interface SalaryIdInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди зарплаты */
  salaryId: InputMaybe<Scalars['Long']['input']>;
}

export interface SalaryInfoWithDetail {
  __typename?: 'SalaryInfoWithDetail';
  /** Счет компании */
  account: Scalars['String']['output'];
  /** Сумма выплаты */
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** Комиссия */
  commission: Maybe<Scalars['BigDecimal']['output']>;
  /** Наименование компании */
  companyName: Scalars['String']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Валюта выплаты */
  currency: Currency;
  /** Айди файла */
  fileId: Maybe<Scalars['Long']['output']>;
  /** Имя загруженного файла */
  fileName: Scalars['String']['output'];
  /** Источник загрузки */
  origin: Origin;
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Детализация по зарплате с пагинацией */
  salaryDetailResponse: PaginatedSalaryDetail;
  /** Айди зарплатного реестра */
  salaryId: Scalars['Long']['output'];
  /** Статус выплаты */
  status: Status;
  /** Общая сумма с учетом комиссии */
  totalAmount: Scalars['BigDecimal']['output'];
  /** Идентификатор обновившего */
  updatedBy: Scalars['String']['output'];
  /** Дата зачисления */
  valueDate: Scalars['Date']['output'];
}

export interface SalaryRecord {
  __typename?: 'SalaryRecord';
  /** Счет компании */
  account: Scalars['String']['output'];
  /** Сумма выплаты */
  amount: Maybe<Scalars['BigDecimal']['output']>;
  /** Комиссия */
  commission: Maybe<Scalars['BigDecimal']['output']>;
  /** Наименование компании */
  companyName: Scalars['String']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Код валюты */
  currency: Scalars['String']['output'];
  /** Айди файла */
  fileId: Maybe<Scalars['Long']['output']>;
  /** Имя загруженного файла */
  fileName: Scalars['String']['output'];
  /** Айди записи */
  id: Scalars['Long']['output'];
  /** Флаг полной обработки */
  isFullComplete: Maybe<Scalars['Boolean']['output']>;
  /** Айди юридического лица */
  legalPartyId: Scalars['Long']['output'];
  /** Источник загрузки */
  origin: Origin;
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Статус выплаты */
  status: Status;
  /** Общая сумма с учетом комиссии */
  totalAmount: Scalars['BigDecimal']['output'];
  /** Идентификатор обновившего */
  updatedBy: Scalars['String']['output'];
  /** Дата зачисления */
  valueDate: Scalars['Date']['output'];
}

export interface SalaryRequest {
  /** Счет */
  account: Scalars['String']['input'];
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Комиссия */
  commission: Scalars['BigDecimal']['input'];
  /** Название компании */
  companyName: Scalars['String']['input'];
  /** Валюта */
  currency: CurrencyInput;
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Детали зарплаты */
  salaryDetails: Array<SalaryDetailInput>;
  /** Итого */
  totalAmount: Scalars['BigDecimal']['input'];
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

export interface SalarySubscriptionDto {
  __typename?: 'SalarySubscriptionDto';
  salaryResponseDto: SalaryRecord;
  state: PaymentSubscriptionStateEnum;
}

export interface SalarySubscriptionResponse {
  __typename?: 'SalarySubscriptionResponse';
  account: Scalars['String']['output'];
  amount: Maybe<Scalars['BigDecimal']['output']>;
  commission: Maybe<Scalars['BigDecimal']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  currency: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  legalPartyId: Scalars['Long']['output'];
  paymentId: Scalars['Long']['output'];
  status: Status;
  totalAmount: Scalars['BigDecimal']['output'];
  valueDate: Scalars['Date']['output'];
}

export interface SalaryTemplate {
  __typename?: 'SalaryTemplate';
  /** Счет компании */
  account: Scalars['String']['output'];
  /** Сумма выплаты */
  amount: Scalars['BigDecimal']['output'];
  /** Комиссия */
  commission: Scalars['BigDecimal']['output'];
  /** Наименование компании */
  companyName: Scalars['String']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Код валюты */
  currency: Scalars['String']['output'];
  /** Айди шаблона */
  id: Scalars['Long']['output'];
  /** Айди юридического лица */
  legalPartyId: Scalars['Long']['output'];
  /** Название шаблона */
  nameTemplate: Scalars['String']['output'];
  /** Детализация по шаблону */
  salaryDetails: Array<SalaryDetailData>;
  /** Общая сумма с учетом комиссии */
  totalAmount: Scalars['BigDecimal']['output'];
  /** Идентификатор обновившего */
  updatedBy: Scalars['String']['output'];
  /** Дата обновления */
  updatedDate: Scalars['LocalDateTime']['output'];
}

export interface SalaryTemplateCriteriaInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Пользователь */
  user: Scalars['String']['input'];
}

export interface SalaryTemplateInput {
  /** Счет компании */
  account: Scalars['String']['input'];
  /** Сумма выплаты */
  amount: Scalars['BigDecimal']['input'];
  /** Комиссия */
  commission: Scalars['BigDecimal']['input'];
  /** Наименование компании */
  companyName: Scalars['String']['input'];
  /** Валюта */
  currency: Scalars['String']['input'];
  /** ID шаблона */
  id: InputMaybe<Scalars['Long']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Название шаблона */
  nameTemplate: Scalars['String']['input'];
  /** Детализация зарплат */
  salaryDetails: Array<SalaryDetailInput>;
  /** Общая сумма */
  totalAmount: Scalars['BigDecimal']['input'];
}

export interface SalePointDto {
  __typename?: 'SalePointDto';
  availableCashCodes: Maybe<Array<Scalars['Long']['output']>>;
  checkName: Maybe<Scalars['String']['output']>;
  contactNumbers: Maybe<Array<Scalars['String']['output']>>;
  salePointAddress: Scalars['String']['output'];
  salePointCode: Maybe<Scalars['Long']['output']>;
  salePointName: Scalars['String']['output'];
}

export interface SaleQrOperationInfoLast2DaysDto {
  __typename?: 'SaleQrOperationInfoLast2DaysDto';
  /** Информация и платежах за сегодняшний день */
  today: Maybe<DailyQrOperationCountAndAmount>;
  /** Информация и платежах за вчерашний день */
  yesterday: Maybe<DailyQrOperationCountAndAmount>;
}

export interface SearchOperationHistoryInput {
  /** Счёт */
  account: InputMaybe<Scalars['String']['input']>;
  /** Сортировать по возрастанию суммы */
  amountAsc: InputMaybe<Scalars['Boolean']['input']>;
  /** Создатель операции */
  creator: InputMaybe<Scalars['String']['input']>;
  /** Валюты */
  currency: Array<Scalars['String']['input']>;
  /** Максимальная сумма */
  endAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Конечная дата */
  endDate: InputMaybe<Scalars['Date']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Типы операций */
  operations: Array<Operations>;
  /** Источник операции */
  origin: InputMaybe<Origin>;
  /** Назначение платежа */
  purpose: InputMaybe<Scalars['String']['input']>;
  /** Имя получателя */
  recipientName: InputMaybe<Scalars['String']['input']>;
  /** Минимальная сумма */
  startAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Начальная дата */
  startDate: InputMaybe<Scalars['Date']['input']>;
  /** Статусы операций */
  status: Array<Status>;
  /** Номер перевода */
  transferNum: InputMaybe<Scalars['String']['input']>;
}

export interface SearchSalary {
  /** Дата окончания */
  endDate: InputMaybe<Scalars['Date']['input']>;
  /** Айди организации */
  legalPartyIdInput: LegalPartyIdInput;
  /** Дата начала */
  startDate: InputMaybe<Scalars['Date']['input']>;
  /** Статус платежа */
  status: Array<Status>;
}

export interface SendPayment2AbsInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Список айди платежей */
  payments: Array<Scalars['Long']['input']>;
  /** Причина отзыва платежа (если есть) */
  revocationReason: InputMaybe<Scalars['String']['input']>;
  /** Вердикт по платежу */
  verdict: Confirm;
}

export interface SignatureInput {
  legalPartyId: Scalars['Long']['input'];
  payments: Array<TokenWithPaymentInput>;
  verdict: Verdict;
}

export interface SignatureSalaryInput {
  legalPartyId: Scalars['Long']['input'];
  salary: TokenWithSalaryInput;
  verdict: Verdict;
}

export interface SignedPaymentInput {
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Валюта */
  currency: Scalars['String']['input'];
  /** Операция */
  operation: Operations;
  /** Счёт плательщика */
  payerAccount: Scalars['String']['input'];
  /** Идентификатор платежа */
  paymentId: Scalars['Long']['input'];
  /** Подпись предыдущего шага */
  prevSign: InputMaybe<Scalars['String']['input']>;
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Счёт получателя */
  recipientAccount: Scalars['String']['input'];
  /** Номер перевода */
  transferNum: Scalars['String']['input'];
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

export interface SignedSalary {
  /** Счёт компании */
  account: Scalars['String']['input'];
  /** Количество карточных счетов */
  amountCardAccounts: Scalars['Int']['input'];
  /** Файл с подписями в формате Base64 */
  base64: Scalars['String']['input'];
  /** Название компании */
  companyName: Scalars['String']['input'];
  /** Валюта */
  currency: Scalars['String']['input'];
  /** Имя файла */
  fileName: Scalars['String']['input'];
  /** Идентификатор платежа */
  paymentId: Scalars['Long']['input'];
  /** Подпись предыдущего шага */
  prevSign: InputMaybe<Scalars['String']['input']>;
  /** Общая сумма выплат */
  totalAmount: Scalars['BigDecimal']['input'];
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

export enum Status {
  /** Отказ первого подписанта */
  CanceledSignOne = 'CANCELED_SIGN_ONE',
  /** Отказ второго подписанта */
  CanceledSignTwo = 'CANCELED_SIGN_TWO',
  /** Сформирован- Платеж сформирован (все поля заполнены правильно) */
  Draft = 'DRAFT',
  /** Не исполнен- Платеж отклонен банком. не прошел контроль в банке. присваивается сервером */
  Error = 'ERROR',
  /** Ожидание запроса на подписание в Pay Control Первым подписантом. */
  FirstSignInPayControl = 'FIRST_SIGN_IN_PAY_CONTROL',
  /** Ожидание подтверждения платежа от Pay Control для Первого подписанта */
  FirstSignInPayControlComplete = 'FIRST_SIGN_IN_PAY_CONTROL_COMPLETE',
  /** Отклонён- Платеж отклонен пользователем с правом доступа на  подтверждение транзакций */
  ForEditing = 'FOR_EDITING',
  /** Обработан Банком */
  Kvit = 'KVIT',
  /** Ожидает отправки платежа */
  OnConfirmation = 'ON_CONFIRMATION',
  /** Успешная отправка платежа */
  OnConfirmationCompleted = 'ON_CONFIRMATION_COMPLETED',
  /** Ожидает первую подпись */
  OnVerification = 'ON_VERIFICATION',
  /** Успешное подписание первой подписи */
  OnVerificationCompleted = 'ON_VERIFICATION_COMPLETED',
  /** Ожидает вторую подпись */
  PartiallyConfirmed = 'PARTIALLY_CONFIRMED',
  /** Успешное подписание второй подписи */
  PartialConfirmationCompleted = 'PARTIAL_CONFIRMATION_COMPLETED',
  /** Запрос на выполнение платежа в АБС */
  PaymentRequestToBank = 'PAYMENT_REQUEST_TO_BANK',
  /** Платёж отозван подписантом во время подтверждения перед отправкой в АБС */
  Revoke = 'REVOKE',
  /** Отправка запроса на подписание в Pay Control Вторым подписантом. */
  SecondSignInPayControl = 'SECOND_SIGN_IN_PAY_CONTROL',
  /** Ожидание подтверждения платежа от Pay Control для Второго подписанта. */
  SecondSignInPayControlComplete = 'SECOND_SIGN_IN_PAY_CONTROL_COMPLETE',
  /** Платеж принят, обработан и проведен банком */
  Success = 'SUCCESS',
  /** Отказ по таймауту для первого подписанта */
  TimeoutCanceledSignOne = 'TIMEOUT_CANCELED_SIGN_ONE',
  /** Отказ по таймауту для второго подписанта */
  TimeoutCanceledSignTwo = 'TIMEOUT_CANCELED_SIGN_TWO',
  /** Отказано по истечению времени */
  TimeIsOut = 'TIME_IS_OUT',
  /** Ожидание ответа по платежу от Рс Банк */
  WaitResponseFromBank = 'WAIT_RESPONSE_FROM_BANK'
}

export interface Subscription {
  __typename?: 'Subscription';
  listenPayment: HistoryPayment;
  listenSalary: SalarySubscriptionDto;
}


export interface SubscriptionListenPaymentArgs {
  legalPartyIdAndPaymentId: InputMaybe<LegalPartyIdAndPaymentIdInput>;
}


export interface SubscriptionListenSalaryArgs {
  salaryIdInput: InputMaybe<SalaryIdInput>;
}

export interface SwiftInput {
  /** Адрес */
  address: Scalars['String']['input'];
  /** Сумма перевода */
  amount: Scalars['BigDecimal']['input'];
  /** Код категории операции */
  categoryCode: OperationTypeCategoryInput;
  /** Город */
  city: Scalars['String']['input'];
  /** Счет комиссии */
  commissionAccount: Scalars['String']['input'];
  /** Валюта комиссии */
  commissionCurrency: CurrencyInput;
  /** Опция комиссии */
  commissionOption: CommissionOption;
  /** Корреспондентский счет */
  corrAccount: InputMaybe<Scalars['String']['input']>;
  /** Страна получателя */
  country: CountryInput;
  /** Валюта перевода */
  currency: CurrencyInput;
  /** ID подразделения */
  departmentId: Scalars['Int']['input'];
  /** Сумма в экзотической валюте */
  exoticAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Экзотическая валюта */
  exoticCurrency: InputMaybe<CurrencyInput>;
  /** Курс экзотической валюты */
  exoticRate: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Банк-посредник */
  intermediaryBankBic: InputMaybe<BankInput>;
  /** Корр. счёт банка-посредника */
  intermediaryCorrAccount: InputMaybe<Scalars['String']['input']>;
  /** Признак экзотического перевода */
  isExotic: Scalars['Boolean']['input'];
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП */
  kpp: InputMaybe<Scalars['String']['input']>;
  /** БИН (Казахстан) */
  kztBin: InputMaybe<Scalars['String']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Операция */
  operation: OperationInput;
  /** Счет плательщика */
  payerAccount: Scalars['String']['input'];
  /** Банк плательщика (BIC) */
  payerBic: BankInput;
  /** Имя плательщика */
  payerName: Scalars['String']['input'];
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['input'];
  /** Банк получателя (BIC) */
  recipientBic: BankInput;
  /** Имя получателя */
  recipientName: Scalars['String']['input'];
  /** Код VO  */
  rubCodeVo: InputMaybe<Scalars['Int']['input']>;
  /** ИНН (руб.) */
  rubInn: InputMaybe<Scalars['String']['input']>;
  /** Номер перевода */
  transferNum: InputMaybe<Scalars['String']['input']>;
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

export interface SwiftPaymentRecord {
  __typename?: 'SwiftPaymentRecord';
  address: Maybe<Scalars['String']['output']>;
  amount: Scalars['BigDecimal']['output'];
  categoryCode: Scalars['String']['output'];
  categoryId: Scalars['Long']['output'];
  city: Maybe<Scalars['String']['output']>;
  commissionAccount: Scalars['String']['output'];
  commissionCurrencyCode: Scalars['String']['output'];
  commissionCurrencyId: Scalars['Int']['output'];
  commissionOption: Scalars['String']['output'];
  corrAccount: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  creatorName: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  currencyId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  exoticAmount: Maybe<Scalars['BigDecimal']['output']>;
  exoticCurrencyCode: Maybe<Scalars['String']['output']>;
  exoticCurrencyId: Maybe<Scalars['Int']['output']>;
  exoticRate: Maybe<Scalars['BigDecimal']['output']>;
  id: Scalars['Long']['output'];
  intermediaryBankCode: Maybe<Scalars['String']['output']>;
  intermediaryBankName: Maybe<Scalars['String']['output']>;
  isExotic: Scalars['Boolean']['output'];
  kpp: Maybe<Scalars['String']['output']>;
  kztBin: Maybe<Scalars['String']['output']>;
  legalPartyId: Scalars['Long']['output'];
  operationCode: Operations;
  origin: Origin;
  payerAccount: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  recipientAccount: Scalars['String']['output'];
  recipientBankCode: Scalars['String']['output'];
  recipientBankName: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  rubCodeVo: Maybe<Scalars['Int']['output']>;
  rubInn: Maybe<Scalars['String']['output']>;
  statusCode: Status;
  transferNum: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  valueDate: Scalars['Date']['output'];
}

export interface TemplateIdInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди шаблона */
  templateId: Scalars['Long']['input'];
}

export interface TemplateInput {
  /** Адрес получателя */
  address: InputMaybe<Scalars['String']['input']>;
  /** Сумма перевода */
  amount: Scalars['BigDecimal']['input'];
  /** Код категории */
  categoryCode: InputMaybe<Scalars['String']['input']>;
  /** Город получателя */
  city: InputMaybe<Scalars['String']['input']>;
  /** Счет комиссии */
  commissionAccount: InputMaybe<Scalars['String']['input']>;
  /** Валюта комиссии */
  commissionCurrency: InputMaybe<Scalars['String']['input']>;
  /** Опция комиссии */
  commissionOption: InputMaybe<Scalars['String']['input']>;
  /** Корреспондентский счет */
  corrAccount: InputMaybe<Scalars['String']['input']>;
  /** Страна получателя */
  country: InputMaybe<Scalars['String']['input']>;
  /** Сумма в экзотической валюте */
  exoticAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Экзотическая валюта */
  exoticCurrency: InputMaybe<Scalars['String']['input']>;
  /** Курс экзотической валюты */
  exoticRate: InputMaybe<Scalars['BigDecimal']['input']>;
  /** ID шаблона */
  id: Scalars['Long']['input'];
  /** БИК банка-посредника */
  intermediaryBankBic: InputMaybe<Scalars['String']['input']>;
  /** Корр. счет банка-посредника */
  intermediaryCorrAccount: InputMaybe<Scalars['String']['input']>;
  /** Признак экзотического перевода */
  isExotic: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП */
  kpp: InputMaybe<Scalars['String']['input']>;
  /** БИН (Казахстан) */
  kztBin: InputMaybe<Scalars['String']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Название шаблона */
  nameTemplate: Scalars['String']['input'];
  /** Операция перевода */
  operation: OperationInput;
  /** Счет плательщика */
  payerAccount: Scalars['String']['input'];
  /** БИК плательщика */
  payerBic: InputMaybe<Scalars['String']['input']>;
  /** Карточный счет плательщика */
  payerCardAccount: InputMaybe<Scalars['String']['input']>;
  /** Номер карты плательщика */
  payerCardNum: InputMaybe<Scalars['String']['input']>;
  /** Тип карты плательщика */
  payerCardType: InputMaybe<Scalars['String']['input']>;
  /** Валюта плательщика */
  payerCurrency: Scalars['String']['input'];
  /** Код платежа */
  paymentCode: InputMaybe<Scalars['String']['input']>;
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['input'];
  /** БИК получателя */
  recipientBic: InputMaybe<Scalars['String']['input']>;
  /** Карточный счет получателя */
  recipientCardAccount: InputMaybe<Scalars['String']['input']>;
  /** Номер карты получателя */
  recipientCardNum: InputMaybe<Scalars['String']['input']>;
  /** Тип карты получателя */
  recipientCardType: InputMaybe<Scalars['String']['input']>;
  /** Реквизиты получателя */
  recipientDetail: Scalars['String']['input'];
  /** ИНН получателя */
  recipientInn: InputMaybe<Scalars['String']['input']>;
  /** Наименование получателя */
  recipientName: InputMaybe<Scalars['String']['input']>;
  /** Код VO (руб.) */
  rubCodeVo: InputMaybe<Scalars['Int']['input']>;
  /** ИНН (руб.) */
  rubInn: InputMaybe<Scalars['String']['input']>;
}

export interface TokenWithPaymentInput {
  signedPayments: SignedPaymentInput;
  tokenHash: InputMaybe<Scalars['String']['input']>;
}

export interface TokenWithSalaryInput {
  signedSalary: SignedSalary;
  tokenHash: InputMaybe<Scalars['String']['input']>;
}

export interface TransferByInvoiceDetailDto {
  __typename?: 'TransferByInvoiceDetailDto';
  /** Сумма операции */
  amount: Scalars['BigDecimal']['output'];
  /** Идентификатор создателя */
  createdBy: Scalars['String']['output'];
  /** Дата создания записи */
  createdDate: Scalars['LocalDateTime']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Айди выставленного счета */
  invoiceId: Scalars['Long']['output'];
  /** Валюта операции */
  isoCode: Scalars['String']['output'];
  /** Айди организации */
  legalPartyId: Scalars['Long']['output'];
  /** Счет списания */
  payerAccount: Scalars['String']['output'];
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Назначение платежа */
  purpose: Scalars['String']['output'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['output'];
  /** Наименование получателя */
  recipientName: Scalars['String']['output'];
  /** Статус операции */
  statusCode: Status;
  /** Номер перевода */
  transferNum: Scalars['String']['output'];
  /** Дата валютирования */
  valueDate: Scalars['LocalDate']['output'];
}

export interface TransferByInvoiceDto {
  __typename?: 'TransferByInvoiceDto';
  /** Сумма операции */
  amount: Scalars['BigDecimal']['output'];
  /** Имя создателя */
  creatorName: Scalars['String']['output'];
  /** Айди выставленного счета */
  invoiceId: Scalars['Long']['output'];
  /** Валюта операции */
  isoCode: Scalars['String']['output'];
  /** Айди платежа */
  paymentId: Scalars['Long']['output'];
  /** Статус операции */
  statusCode: Status;
}

export interface TransferInput {
  /** Сумма */
  amount: Scalars['BigDecimal']['input'];
  /** Валюта */
  currency: CurrencyInput;
  /** ID подразделения */
  departmentId: Scalars['Int']['input'];
  /** Это флоу упрощенного подписания или нет */
  isInstantPayment: InputMaybe<Scalars['Boolean']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Операция */
  operation: OperationInput;
  /** Счёт плательщика */
  payerAccount: Scalars['String']['input'];
  /** Банк плательщика (BIC) */
  payerBic: BankInput;
  /** ИНН плательщика */
  payerInn: Scalars['String']['input'];
  /** Имя плательщика */
  payerName: Scalars['String']['input'];
  /** Код назначения платежа (КБК) */
  paymentCode: InputMaybe<BudgetClassificationCodeInput>;
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Счёт получателя */
  recipientAccount: Scalars['String']['input'];
  /** Валюта счёта получателя */
  recipientAccountCurrency: CurrencyInput;
  /** Банк получателя (BIC) */
  recipientBic: BankInput;
  /** Имя получателя */
  recipientName: Scalars['String']['input'];
  /** Номер перевода */
  transferNum: InputMaybe<Scalars['String']['input']>;
  /** Дата валютирования */
  valueDate: Scalars['Date']['input'];
}

/**
 *     intermediaryBankBic:String
 *     commissionAccount:String
 *     commissionOption:String
 *     commissionCurrency:String
 *     kpp:String
 *     country:String
 *     codeVo:Int
 *     codeBinOperation:String
 * }
 */
export interface TransferPaymentRecord {
  __typename?: 'TransferPaymentRecord';
  amount: Scalars['BigDecimal']['output'];
  commission: Scalars['BigDecimal']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  creatorName: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  currencyId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  legalPartyId: Scalars['Long']['output'];
  operationCode: Operations;
  origin: Origin;
  payerAccount: Scalars['String']['output'];
  payerBic: Scalars['String']['output'];
  payerBicName: Scalars['String']['output'];
  payerInn: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  paymentCode: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
  recipientAccount: Scalars['String']['output'];
  recipientBic: Scalars['String']['output'];
  recipientBicName: Scalars['String']['output'];
  recipientInn: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  statusCode: Status;
  transferNum: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  valueDate: Scalars['Date']['output'];
}

export interface TransferTemplateCriteriaInput {
  /** Айди организации */
  legalPartyId: Scalars['Long']['input'];
  /** Айди операций */
  operationIds: Array<Scalars['Long']['input']>;
}

export interface TransferTemplateInput {
  /** Адрес получателя */
  address: InputMaybe<Scalars['String']['input']>;
  /** Сумма перевода */
  amount: Scalars['BigDecimal']['input'];
  /** Код категории */
  categoryCode: InputMaybe<Scalars['String']['input']>;
  /** Город получателя */
  city: InputMaybe<Scalars['String']['input']>;
  /** Счет комиссии */
  commissionAccount: InputMaybe<Scalars['String']['input']>;
  /** Валюта комиссии */
  commissionCurrency: InputMaybe<Scalars['String']['input']>;
  /** Опция комиссии */
  commissionOption: InputMaybe<Scalars['String']['input']>;
  /** Корреспондентский счет */
  corrAccount: InputMaybe<Scalars['String']['input']>;
  /** Страна получателя */
  country: InputMaybe<Scalars['String']['input']>;
  /** Сумма в экзотической валюте */
  exoticAmount: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Экзотическая валюта */
  exoticCurrency: InputMaybe<Scalars['String']['input']>;
  /** Курс экзотической валюты */
  exoticRate: InputMaybe<Scalars['BigDecimal']['input']>;
  /** БИК банка-посредника */
  intermediaryBankBic: InputMaybe<Scalars['String']['input']>;
  /** Корр. счет банка-посредника */
  intermediaryCorrAccount: InputMaybe<Scalars['String']['input']>;
  /** Признак экзотического перевода */
  isExotic: InputMaybe<Scalars['Boolean']['input']>;
  /** КПП */
  kpp: InputMaybe<Scalars['String']['input']>;
  /** БИН (Казахстан) */
  kztBin: InputMaybe<Scalars['String']['input']>;
  /** ID юридического лица */
  legalPartyId: Scalars['Long']['input'];
  /** Название шаблона */
  nameTemplate: Scalars['String']['input'];
  /** Операция перевода */
  operation: OperationInput;
  /** Счет плательщика */
  payerAccount: Scalars['String']['input'];
  /** БИК плательщика */
  payerBic: InputMaybe<Scalars['String']['input']>;
  /** Карточный счет плательщика */
  payerCardAccount: InputMaybe<Scalars['String']['input']>;
  /** Номер карты плательщика */
  payerCardNum: InputMaybe<Scalars['String']['input']>;
  /** Тип карты плательщика */
  payerCardType: InputMaybe<Scalars['String']['input']>;
  /** Валюта плательщика */
  payerCurrency: Scalars['String']['input'];
  /** Код платежа */
  paymentCode: InputMaybe<Scalars['String']['input']>;
  /** Назначение платежа */
  purpose: Scalars['String']['input'];
  /** Счет получателя */
  recipientAccount: Scalars['String']['input'];
  /** БИК получателя */
  recipientBic: InputMaybe<Scalars['String']['input']>;
  /** Карточный счет получателя */
  recipientCardAccount: InputMaybe<Scalars['String']['input']>;
  /** Номер карты получателя */
  recipientCardNum: InputMaybe<Scalars['String']['input']>;
  /** Тип карты получателя */
  recipientCardType: InputMaybe<Scalars['String']['input']>;
  /** Реквизиты получателя */
  recipientDetail: Scalars['String']['input'];
  /** ИНН получателя */
  recipientInn: InputMaybe<Scalars['String']['input']>;
  /** Наименование получателя */
  recipientName: InputMaybe<Scalars['String']['input']>;
  /** Код VO (руб.) */
  rubCodeVo: InputMaybe<Scalars['Int']['input']>;
  /** ИНН (руб.) */
  rubInn: InputMaybe<Scalars['String']['input']>;
}

export interface TransferTemplates {
  __typename?: 'TransferTemplates';
  address: Maybe<Scalars['String']['output']>;
  amount: Scalars['BigDecimal']['output'];
  categoryCode: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  commissionAccount: Maybe<Scalars['String']['output']>;
  commissionCurrency: Maybe<Scalars['String']['output']>;
  commissionOption: Maybe<Scalars['String']['output']>;
  corrAccount: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['LocalDateTime']['output'];
  exoticAmount: Maybe<Scalars['BigDecimal']['output']>;
  exoticCurrency: Maybe<Scalars['String']['output']>;
  exoticRate: Maybe<Scalars['BigDecimal']['output']>;
  id: Scalars['Long']['output'];
  intermediaryBankBic: Maybe<Scalars['String']['output']>;
  intermediaryCorrAccount: Maybe<Scalars['String']['output']>;
  isExotic: Maybe<Scalars['Boolean']['output']>;
  kpp: Maybe<Scalars['String']['output']>;
  kztBin: Maybe<Scalars['String']['output']>;
  legalPartyId: Scalars['Long']['output'];
  nameTemplate: Scalars['String']['output'];
  operations: Operations;
  payerAccount: Scalars['String']['output'];
  payerBic: Maybe<Scalars['String']['output']>;
  payerCardAccount: Maybe<Scalars['String']['output']>;
  payerCardNum: Maybe<Scalars['String']['output']>;
  payerCardType: Maybe<Scalars['String']['output']>;
  payerCurrency: Scalars['String']['output'];
  paymentCode: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
  recipientAccount: Scalars['String']['output'];
  recipientBic: Maybe<Scalars['String']['output']>;
  recipientCardAccount: Maybe<Scalars['String']['output']>;
  recipientCardNum: Maybe<Scalars['String']['output']>;
  recipientCardType: Maybe<Scalars['String']['output']>;
  recipientDetail: Maybe<Scalars['String']['output']>;
  recipientInn: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  rubCodeVo: Maybe<Scalars['Int']['output']>;
  rubInn: Maybe<Scalars['String']['output']>;
}

export interface UpdatePayment {
  /** Идентификатор платежа */
  id: Scalars['Long']['input'];
  /** Обновление перевода по карте */
  updateCardTransferInput: InputMaybe<CardTransferInput>;
  /** Обновление SWIFT-перевода */
  updateSwiftInput: InputMaybe<SwiftInput>;
  /** Обновление перевода по счету на оплату */
  updateTransferByInvoice: InputMaybe<QrTransferInput>;
  /** Обновление банковского перевода */
  updateTransferInput: InputMaybe<TransferInput>;
}

/** -------ENUM-------------- */
export enum Verdict {
  Cancelled = 'CANCELLED',
  Revision = 'REVISION',
  Success = 'SUCCESS'
}

export type CurrencyForPaymentFragment = { __typename?: 'Currency', id: number | null, isoNum: string, isoCode: string };

export type BankFragment = { __typename?: 'Banks', id: number, partyBankId: number | null, bankCode: string, bankName: string, corAccount: string | null, absBankCode: number | null, isActive: boolean };

export type CountryFragment = { __typename?: 'Country', id: number, numInList: string, fullName: string };

export type OperationFragment = { __typename?: 'Operation', id: number, operationCode: string, isActive: boolean };

export type BudgetClassificationCodeFragment = { __typename?: 'BudgetClassificationCode', id: number, classCode: string, className: string, isActive: boolean };

export type OperationTypeCategoryFragment = { __typename?: 'OperationTypeCategory', id: number, categoryCode: string, categoryName: string, isActive: boolean };

export type OperationHistoryByCriteriaFragment = { __typename?: 'OperationHistoryByCriteria', id: number, createdDate: string, createdBy: string, updatedBy: string, recipientAccount: string, operationCode: Operations, transferNum: string, valueDate: string, payerAccount: string, amount: number, currency: string, statusCode: Status, purpose: string, recipientName: string, legalPartyId: number, paymentDetailsId: number, description: string, origin: Origin };

export type PaginatedOperationHistoryByCriteriaFragment = { __typename?: 'PaginatedOperationHistoryByCriteria', amountPages: number, amountElements: number, currentPage: number, list: Array<{ __typename?: 'OperationHistoryByCriteria', id: number, createdDate: string, createdBy: string, updatedBy: string, recipientAccount: string, operationCode: Operations, transferNum: string, valueDate: string, payerAccount: string, amount: number, currency: string, statusCode: Status, purpose: string, recipientName: string, legalPartyId: number, paymentDetailsId: number, description: string, origin: Origin }> };

export type TransferPaymentRecordFragment = { __typename?: 'TransferPaymentRecord', id: number, createdDate: string, createdBy: string, updatedBy: string, legalPartyId: number, operationCode: Operations, description: string | null, amount: number, currencyId: number, currencyCode: string, payerAccount: string, payerBic: string, payerBicName: string, payerInn: string, payerName: string, paymentCode: string | null, purpose: string, recipientAccount: string, recipientBic: string, recipientBicName: string, recipientInn: string | null, recipientName: string, transferNum: string, valueDate: string, statusCode: Status, creatorName: string, origin: Origin };

export type ConversionPaymentRecordFragment = { __typename?: 'ConversionPaymentRecord', id: number, createdDate: string, createdBy: string, updatedBy: string, legalPartyId: number, operationCode: Operations, description: string | null, amount: number, recipientAmount: number, rate: number, currencyId: number, currencyCode: string, payerAccount: string, payerBic: string, payerBicName: string, payerName: string, recipientAccount: string, transferNum: string, valueDate: string, statusCode: Status, recipientCurrencyCode: string, recipientCurrencyId: number, isFixedRate: boolean, creatorName: string };

export type SwiftPaymentRecordFragment = { __typename?: 'SwiftPaymentRecord', id: number, createdDate: string, createdBy: string, updatedBy: string, legalPartyId: number, operationCode: Operations, transferNum: string, valueDate: string, payerName: string, payerAccount: string, currencyId: number, currencyCode: string, amount: number, recipientName: string, recipientAccount: string, recipientBankCode: string, recipientBankName: string, purpose: string, commissionAccount: string, commissionOption: string, commissionCurrencyId: number, commissionCurrencyCode: string, rubInn: string | null, categoryId: number, categoryCode: string, corrAccount: string | null, kpp: string | null, country: string, rubCodeVo: number | null, kztBin: string | null, statusCode: Status, description: string | null, intermediaryBankCode: string | null, isExotic: boolean, exoticAmount: number | null, exoticCurrencyCode: string | null, exoticRate: number | null, creatorName: string, origin: Origin, city: string | null, address: string | null };

export type CardTransferRecordFragment = { __typename?: 'CardTransferRecord', id: number, createdDate: string, statusCode: Status, amount: number, currencyId: number, currencyCode: string, operationCode: Operations, purpose: string, valueDate: string, transferNum: string, paymentCode: string | null, createdBy: string, creatorName: string, recipientName: string, recipientCardNum: string | null, recipientAccount: string, recipientCurrencyCode: string, recipientInn: string, recipientBic: string, recipientBicName: string, recipientDetail: string, cardReferencesId: string | null, legalPartyId: number, description: string | null, payerName: string, payerAccount: string, origin: Origin };

export type BudgetPaymentRecordFragment = { __typename?: 'BudgetPaymentRecord', id: number, createdDate: string, createdBy: string, creatorName: string, updatedBy: string, legalPartyId: number, description: string | null, operationCode: Operations, transferNum: string, valueDate: string, recipientAccount: string, payerAccount: string, statusCode: Status, paymentCode: string, amount: number, commission: number, paylogicId: number, purpose: string, currency: string };

export type TransferByInvoiceDetailFragment = { __typename?: 'TransferByInvoiceDetailDto', amount: number, creatorName: string, invoiceId: number, isoCode: string, legalPartyId: number, payerAccount: string, paymentId: number, purpose: string, recipientAccount: string, recipientName: string, statusCode: Status, valueDate: any, createdBy: string, createdDate: string, transferNum: string };

export type RefundedQrOperationRecordFragment = { __typename?: 'QrRefundedOperationInfo', cardTransferRko2CardRecord: { __typename?: 'QrRefundRecord', id: number, createdDate: string, statusCode: Status, amount: number, currencyCode: string, operationCode: Operations, purpose: string, creatorName: string, recipientName: string, recipientCardNum: string | null, recipientAccount: string, recipientBic: string, recipientBicName: string, description: string | null, payerName: string, payerAccount: string, recipientDetail: string }, salePointDto: { __typename?: 'SalePointDto', salePointName: string } | null };

export type PaymentStatusHistoryFragment = { __typename?: 'PaymentStatusHistory', id: number, updatedBy: string, statusCode: Status, updatedDate: string };

export type TransferTemplateFragment = { __typename?: 'TransferTemplates', id: number, createdDate: string, createdBy: string, legalPartyId: number, operations: Operations, nameTemplate: string, payerAccount: string, payerCurrency: string, payerBic: string | null, amount: number, recipientBic: string | null, recipientAccount: string, recipientName: string | null, recipientInn: string | null, paymentCode: string | null, categoryCode: string | null, purpose: string, commissionAccount: string | null, commissionCurrency: string | null, commissionOption: string | null, corrAccount: string | null, country: string | null, rubCodeVo: number | null, rubInn: string | null, kpp: string | null, kztBin: string | null, intermediaryBankBic: string | null, intermediaryCorrAccount: string | null, exoticAmount: number | null, exoticRate: number | null, exoticCurrency: string | null, isExotic: boolean | null, payerCardAccount: string | null, payerCardNum: string | null, payerCardType: string | null, recipientCardAccount: string | null, recipientCardNum: string | null, recipientCardType: string | null, recipientDetail: string | null, city: string | null, address: string | null };

export type HistoryPaymentFragment = { __typename?: 'HistoryPayment', state: PaymentSubscriptionStateEnum, paymentInformation: { __typename?: 'OperationHistoryByCriteria', id: number, createdDate: string, createdBy: string, updatedBy: string, recipientAccount: string, operationCode: Operations, transferNum: string, valueDate: string, payerAccount: string, amount: number, currency: string, statusCode: Status, purpose: string, recipientName: string, legalPartyId: number, paymentDetailsId: number, description: string, origin: Origin } };

export type RecordTokensFragment = { __typename?: 'RecordTokens', id: number, token: string };

export type RecordPaymentsFragment = { __typename?: 'RecordPayments', status: PaymentStatus, id: number };

export type CurrencyRateFragment = { __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number };

export type CurrencyRatesFragment = { __typename?: 'CurrencyRatesDto', cash: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, cashless: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, card: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, nbkr: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }> };

export type CurrencyRatesConversionFragment = { __typename?: 'CurrencyRatesDto', cashless: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, nbkr: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }> };

export type PaymentCommissionFragment = { __typename?: 'CommissionResponse', totalAmount: number, commissionAmount: number };

export type CardTransferRko2CardRecordFragment = { __typename?: 'CardTransferRecord', id: number, createdDate: string, statusCode: Status, amount: number, currencyId: number, currencyCode: string, operationCode: Operations, purpose: string, valueDate: string, transferNum: string, paymentCode: string | null, createdBy: string, creatorName: string, recipientName: string, recipientAccount: string, recipientCardNum: string | null, recipientCurrencyCode: string, recipientInn: string, recipientBic: string, recipientBicName: string, recipientDetail: string, cardReferencesId: string | null, legalPartyId: number, description: string | null, payerName: string, payerAccount: string, origin: Origin };

export type QrOperationInfoFragment = { __typename?: 'QrOperationInfo', id: string, createdDate: string, createdTime: string, amountWithFee: number, amountWithoutFee: number, origin: string, senderName: string | null, recipientName: string | null, account: string, feePercent: number, feeAmount: number, qrComment: string | null, stan: string, operationTypeGroup: OperationTypeGroup | null, qrAccount: string, salePointName: string | null, cashCode: string | null, providerTransactionId: string | null, description: string | null };

export type QrOperationPaginatedFragment = { __typename?: 'PaginatedQrOperationInfo', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrOperationInfo', id: string, createdDate: string, createdTime: string, amountWithFee: number, amountWithoutFee: number, origin: string, senderName: string | null, recipientName: string | null, account: string, feePercent: number, feeAmount: number, qrComment: string | null, stan: string, operationTypeGroup: OperationTypeGroup | null, qrAccount: string, salePointName: string | null, cashCode: string | null, providerTransactionId: string | null, description: string | null }> };

export type DailyQrOperationCountAndAmountFragment = { __typename?: 'DailyQrOperationCountAndAmount', totalAmount: number, operationCount: number };

export type SaleQrOperationInfoLast2DaysFragment = { __typename?: 'SaleQrOperationInfoLast2DaysDto', today: { __typename?: 'DailyQrOperationCountAndAmount', totalAmount: number, operationCount: number } | null, yesterday: { __typename?: 'DailyQrOperationCountAndAmount', totalAmount: number, operationCount: number } | null };

export type QrTransferRecordFragment = { __typename?: 'QrTransferRecordById', createdDateTime: string, statusCode: Status, amount: number, currencyCode: string, purpose: string | null, transferNum: string, creatorName: string, commission: number, commissionPercent: number, legalPartyId: number, paymentId: number, recipientName: string, description: string | null };

export type QrTransferHistoryRecordFragment = { __typename?: 'QrTransferRecordByFilter', transferNum: string, elqrTransferType: QrTransferType, qrTransferDirection: QrTransferDirection, createdDateTime: string, creatorName: string | null, payerAccount: string, recipientName: string | null, qrAccount: string | null, amount: number, status: Status, currencyCode: string, commission: number, commissionPercent: number, purpose: string | null, paymentId: number };

export type PaginatedQrTransferHistoryRecordsFragment = { __typename?: 'PaginatedQrTransferRecordsByFilter', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrTransferRecordByFilter', transferNum: string, elqrTransferType: QrTransferType, qrTransferDirection: QrTransferDirection, createdDateTime: string, creatorName: string | null, payerAccount: string, recipientName: string | null, qrAccount: string | null, amount: number, status: Status, currencyCode: string, commission: number, commissionPercent: number, purpose: string | null, paymentId: number }> };

export type SalaryRecordFragment = { __typename?: 'SalaryRecord', id: number, fileName: string, createdDate: string, paymentId: number, status: Status, totalAmount: number, currency: string, origin: Origin, fileId: number | null, isFullComplete: boolean | null };

export type PaginatedSalaryFragment = { __typename?: 'PaginatedSalary', amountPages: number, amountElements: number, list: Array<{ __typename?: 'SalaryRecord', id: number, fileName: string, createdDate: string, paymentId: number, status: Status, totalAmount: number, currency: string, origin: Origin, fileId: number | null, isFullComplete: boolean | null }> };

export type SalaryDetailResponseFragment = { __typename?: 'SalaryDetailResponse', id: number, fullName: string, cardAccount: string, amount: number, state: boolean | null };

export type PaginatedSalaryDetailFragment = { __typename?: 'PaginatedSalaryDetail', amountElements: number, amountPages: number, list: Array<{ __typename?: 'SalaryDetailResponse', id: number, fullName: string, cardAccount: string, amount: number, state: boolean | null }> };

export type SalaryInfoWithDetailFragment = { __typename?: 'SalaryInfoWithDetail', paymentId: number, salaryId: number, fileName: string, totalAmount: number, status: Status, createdDate: string, creatorName: string, valueDate: string, account: string, origin: Origin, fileId: number | null, companyName: string, currency: { __typename?: 'Currency', isoCode: string }, salaryDetailResponse: { __typename?: 'PaginatedSalaryDetail', amountElements: number, amountPages: number, list: Array<{ __typename?: 'SalaryDetailResponse', id: number, fullName: string, cardAccount: string, amount: number, state: boolean | null }> } };

export type SalaryInfoWithDetailForSignFragment = { __typename?: 'SalaryInfoWithDetail', paymentId: number, salaryId: number, fileName: string, totalAmount: number, createdDate: string, valueDate: string, account: string, companyName: string, origin: Origin, fileId: number | null, currency: { __typename?: 'Currency', isoCode: string }, salaryDetailResponse: { __typename?: 'PaginatedSalaryDetail', amountElements: number } };

export type SalarySubscriptionFragment = { __typename?: 'SalarySubscriptionDto', state: PaymentSubscriptionStateEnum, salaryResponseDto: { __typename?: 'SalaryRecord', id: number, fileName: string, createdDate: string, paymentId: number, status: Status, totalAmount: number, currency: string, origin: Origin, fileId: number | null, isFullComplete: boolean | null } };

export type QrOperationInfoInstallmentFragment = { __typename?: 'QrOperationInfo', id: string, amountWithFee: number, createdDate: string, senderName: string | null, stan: string, salePointName: string | null, operationType: string | null, qrOperationStatus: string | null };

export type PaginatedQrOperationInfoFragment = { __typename?: 'PaginatedQrOperationInfo', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrOperationInfo', id: string, amountWithFee: number, createdDate: string, senderName: string | null, stan: string, salePointName: string | null, operationType: string | null, qrOperationStatus: string | null }> };

export type PersonalQrOperationInfoFragment = { __typename?: 'QrOperationInfo', id: string, createdDate: string, createdTime: string, amountWithFee: number, amountWithoutFee: number, origin: string, senderName: string | null, recipientName: string | null, account: string, feePercent: number, feeAmount: number, qrComment: string | null, stan: string, operationTypeGroup: OperationTypeGroup | null, qrAccount: string, salePointName: string | null, cashCode: string | null, providerTransactionId: string | null, description: string | null };

export type PersonalQrOperationPaginatedFragment = { __typename?: 'PaginatedQrOperationInfo', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrOperationInfo', id: string, createdDate: string, createdTime: string, amountWithFee: number, amountWithoutFee: number, origin: string, senderName: string | null, recipientName: string | null, account: string, feePercent: number, feeAmount: number, qrComment: string | null, stan: string, operationTypeGroup: OperationTypeGroup | null, qrAccount: string, salePointName: string | null, cashCode: string | null, providerTransactionId: string | null, description: string | null }> };

export type UpdatePaymentMutationVariables = Exact<{
  updatePayment: UpdatePayment;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'RecordId', id: number } };

export type SaveInterBankTransferNativeDraftMutationVariables = Exact<{
  interBankTransfer: TransferInput;
}>;


export type SaveInterBankTransferNativeDraftMutation = { __typename?: 'Mutation', saveInterBankTransferNativeDraft: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveIntraBankOwnerTransferDraftMutationVariables = Exact<{
  intraTransfer: TransferInput;
}>;


export type SaveIntraBankOwnerTransferDraftMutation = { __typename?: 'Mutation', saveIntraBankOwnerTransferDraft: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveCardTransferMutationVariables = Exact<{
  cardTransfer: CardTransferInput;
}>;


export type SaveCardTransferMutation = { __typename?: 'Mutation', saveCardTransfer: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveIntraBankForeignTransferDraftMutationVariables = Exact<{
  intraTransfer: TransferInput;
}>;


export type SaveIntraBankForeignTransferDraftMutation = { __typename?: 'Mutation', saveIntraBankForeignTransferDraft: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveConversionDraftMutationVariables = Exact<{
  conversion: ConversionInput;
}>;


export type SaveConversionDraftMutation = { __typename?: 'Mutation', saveConversionDraft: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveSwiftMutationVariables = Exact<{
  swift: SwiftInput;
}>;


export type SaveSwiftMutation = { __typename?: 'Mutation', saveSwift: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SigningPaymentMutationVariables = Exact<{
  sign: SignatureInput;
}>;


export type SigningPaymentMutation = { __typename?: 'Mutation', signingPayment: Array<{ __typename?: 'RecordPayments', status: PaymentStatus, id: number }> };

export type DeletePaymentMutationVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: { __typename?: 'RecordId', id: number } };

export type ForSigningPaymentMutationVariables = Exact<{
  payment: PaymentIdListInput;
}>;


export type ForSigningPaymentMutation = { __typename?: 'Mutation', forSigningPayment: Array<{ __typename?: 'RecordPayments', id: number, status: PaymentStatus }> };

export type SaveTransferTemplateMutationVariables = Exact<{
  template: TransferTemplateInput;
}>;


export type SaveTransferTemplateMutation = { __typename?: 'Mutation', saveTransferTemplate: boolean };

export type UpdateTemplateMutationVariables = Exact<{
  template: InputMaybe<TemplateInput>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate: boolean };

export type DeleteTemplateMutationVariables = Exact<{
  template: TemplateIdInput;
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: boolean };

export type RecallPaymentMutationVariables = Exact<{
  paymentIdListInput: PaymentIdListInput;
}>;


export type RecallPaymentMutation = { __typename?: 'Mutation', recallPayment: Array<{ __typename?: 'RecordPayments', id: number, status: PaymentStatus }> };

export type SaveBudgetPaymentMutationVariables = Exact<{
  budgetPayment: BudgetPaymentInput;
}>;


export type SaveBudgetPaymentMutation = { __typename?: 'Mutation', saveBudgetPayment: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type RefundOperationMutationVariables = Exact<{
  refundInput: RefundInput;
}>;


export type RefundOperationMutation = { __typename?: 'Mutation', refundOperation: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveQrTransferMutationVariables = Exact<{
  qrTransferInput: QrTransferInput;
}>;


export type SaveQrTransferMutation = { __typename?: 'Mutation', saveQrTransfer: { __typename?: 'PaymentPcTransactionId', paymentId: number, pcTransactionId: string | null } };

export type SaveSalaryMutationVariables = Exact<{
  salaryRequest: SalaryRequest;
}>;


export type SaveSalaryMutation = { __typename?: 'Mutation', saveSalary: { __typename?: 'RecordId', id: number } };

export type SigningSalaryMutationVariables = Exact<{
  sign: SignatureSalaryInput;
}>;


export type SigningSalaryMutation = { __typename?: 'Mutation', signingSalary: { __typename?: 'RecordPayments', id: number, status: PaymentStatus } };

export type GetAllOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOperationQuery = { __typename?: 'Query', getAllOperation: Array<{ __typename?: 'Operation', id: number, operationCode: string, isActive: boolean }> };

export type GetAllCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountryQuery = { __typename?: 'Query', getAllCountry: Array<{ __typename?: 'Country', id: number, numInList: string, fullName: string }> };

export type GetModelProcessQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type GetModelProcessQuery = { __typename?: 'Query', getModelProcess: string | null };

export type GetBanksByCodeQueryVariables = Exact<{
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankType: BankType;
  pageable: PageInput;
}>;


export type GetBanksByCodeQuery = { __typename?: 'Query', findBankByCodeCriteria: { __typename?: 'PaginatedBank', amountPages: number, amountElements: number, list: Array<{ __typename?: 'Banks', id: number, partyBankId: number | null, bankCode: string, bankName: string, corAccount: string | null, absBankCode: number | null, isActive: boolean }> } };

export type GetBudgetClassificationsByCodeQueryVariables = Exact<{
  budgetClassificationCode: InputMaybe<Scalars['String']['input']>;
  pageable: PageInput;
}>;


export type GetBudgetClassificationsByCodeQuery = { __typename?: 'Query', findBudgetClassificationByCodeCriteria: { __typename?: 'PaginatedBudgetClassificationCode', amountPages: number, amountElements: number, list: Array<{ __typename?: 'BudgetClassificationCode', id: number, classCode: string, className: string, isActive: boolean }> } };

export type GetOperationTypeCategoryByCodeQueryVariables = Exact<{
  operationTypeCode: InputMaybe<Scalars['String']['input']>;
  pageable: PageInput;
}>;


export type GetOperationTypeCategoryByCodeQuery = { __typename?: 'Query', findOperationTypeCategoryByCodeCriteria: { __typename?: 'PaginatedOperationTypeCategory', amountPages: number, amountElements: number, list: Array<{ __typename?: 'OperationTypeCategory', id: number, categoryCode: string, categoryName: string, isActive: boolean }> } };

export type SearchPaymentByCriteriaQueryVariables = Exact<{
  searchOperationHistory: SearchOperationHistoryInput;
  pageable: PageInput;
}>;


export type SearchPaymentByCriteriaQuery = { __typename?: 'Query', searchPaymentByCriteria: { __typename?: 'PaginatedOperationHistoryByCriteria', amountPages: number, amountElements: number, currentPage: number, list: Array<{ __typename?: 'OperationHistoryByCriteria', id: number, createdDate: string, createdBy: string, updatedBy: string, recipientAccount: string, operationCode: Operations, transferNum: string, valueDate: string, payerAccount: string, amount: number, currency: string, statusCode: Status, purpose: string, recipientName: string, legalPartyId: number, paymentDetailsId: number, description: string, origin: Origin }> } };

export type FindTransferDataByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindTransferDataByPaymentIdQuery = { __typename?: 'Query', findTransferDataByPaymentId: { __typename?: 'TransferPaymentRecord', id: number, createdDate: string, createdBy: string, updatedBy: string, legalPartyId: number, operationCode: Operations, description: string | null, amount: number, currencyId: number, currencyCode: string, payerAccount: string, payerBic: string, payerBicName: string, payerInn: string, payerName: string, paymentCode: string | null, purpose: string, recipientAccount: string, recipientBic: string, recipientBicName: string, recipientInn: string | null, recipientName: string, transferNum: string, valueDate: string, statusCode: Status, creatorName: string, origin: Origin } };

export type FindConversionDataByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindConversionDataByPaymentIdQuery = { __typename?: 'Query', findConversionDataByPaymentId: { __typename?: 'ConversionPaymentRecord', id: number, createdDate: string, createdBy: string, updatedBy: string, legalPartyId: number, operationCode: Operations, description: string | null, amount: number, recipientAmount: number, rate: number, currencyId: number, currencyCode: string, payerAccount: string, payerBic: string, payerBicName: string, payerName: string, recipientAccount: string, transferNum: string, valueDate: string, statusCode: Status, recipientCurrencyCode: string, recipientCurrencyId: number, isFixedRate: boolean, creatorName: string } };

export type FindCardTransferDataByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindCardTransferDataByPaymentIdQuery = { __typename?: 'Query', findCardTransferDataByPaymentId: { __typename?: 'CardTransferRecord', id: number, createdDate: string, statusCode: Status, amount: number, currencyId: number, currencyCode: string, operationCode: Operations, purpose: string, valueDate: string, transferNum: string, paymentCode: string | null, createdBy: string, creatorName: string, recipientName: string, recipientCardNum: string | null, recipientAccount: string, recipientCurrencyCode: string, recipientInn: string, recipientBic: string, recipientBicName: string, recipientDetail: string, cardReferencesId: string | null, legalPartyId: number, description: string | null, payerName: string, payerAccount: string, origin: Origin } };

export type FindRefundedQrOperationInfoQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindRefundedQrOperationInfoQuery = { __typename?: 'Query', findRefundedQrOperationInfo: { __typename?: 'QrRefundedOperationInfo', cardTransferRko2CardRecord: { __typename?: 'QrRefundRecord', id: number, createdDate: string, statusCode: Status, amount: number, currencyCode: string, operationCode: Operations, purpose: string, creatorName: string, recipientName: string, recipientCardNum: string | null, recipientAccount: string, recipientBic: string, recipientBicName: string, description: string | null, payerName: string, payerAccount: string, recipientDetail: string }, salePointDto: { __typename?: 'SalePointDto', salePointName: string } | null } };

export type FindQrTransferDataByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindQrTransferDataByPaymentIdQuery = { __typename?: 'Query', findQrTransferDataByPaymentId: { __typename?: 'QrTransferRecordById', createdDateTime: string, statusCode: Status, amount: number, currencyCode: string, purpose: string | null, transferNum: string, creatorName: string, commission: number, commissionPercent: number, legalPartyId: number, paymentId: number, recipientName: string, description: string | null } };

export type FindBudgetPaymentDataByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindBudgetPaymentDataByPaymentIdQuery = { __typename?: 'Query', findBudgetPaymentDataByPaymentId: { __typename?: 'BudgetPaymentRecord', id: number, createdDate: string, createdBy: string, creatorName: string, updatedBy: string, legalPartyId: number, description: string | null, operationCode: Operations, transferNum: string, valueDate: string, recipientAccount: string, payerAccount: string, statusCode: Status, paymentCode: string, amount: number, commission: number, paylogicId: number, purpose: string, currency: string } };

export type CalculateExoticAmountInSwiftQueryVariables = Exact<{
  calculateAmount: CalculateExoticAmountInput;
}>;


export type CalculateExoticAmountInSwiftQuery = { __typename?: 'Query', calculateExoticAmountInSwift: number };

export type FindAllCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCurrencyQuery = { __typename?: 'Query', findAllCurrency: Array<{ __typename?: 'Currency', id: number | null, isoNum: string, isoCode: string }> };

export type FindSwiftDataByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type FindSwiftDataByPaymentIdQuery = { __typename?: 'Query', findSwiftDataByPaymentId: { __typename?: 'SwiftPaymentRecord', id: number, createdDate: string, createdBy: string, updatedBy: string, legalPartyId: number, operationCode: Operations, transferNum: string, valueDate: string, payerName: string, payerAccount: string, currencyId: number, currencyCode: string, amount: number, recipientName: string, recipientAccount: string, recipientBankCode: string, recipientBankName: string, purpose: string, commissionAccount: string, commissionOption: string, commissionCurrencyId: number, commissionCurrencyCode: string, rubInn: string | null, categoryId: number, categoryCode: string, corrAccount: string | null, kpp: string | null, country: string, rubCodeVo: number | null, kztBin: string | null, statusCode: Status, description: string | null, intermediaryBankCode: string | null, isExotic: boolean, exoticAmount: number | null, exoticCurrencyCode: string | null, exoticRate: number | null, creatorName: string, origin: Origin, city: string | null, address: string | null } };

export type GetPaymentStatusHistoryByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type GetPaymentStatusHistoryByPaymentIdQuery = { __typename?: 'Query', getPaymentStatusHistoryByPaymentId: Array<{ __typename?: 'PaymentStatusHistory', id: number, updatedBy: string, statusCode: Status, updatedDate: string }> };

export type GetPaymentSignerInfoByPaymentIdQueryVariables = Exact<{
  payment: PaymentIdInput;
}>;


export type GetPaymentSignerInfoByPaymentIdQuery = { __typename?: 'Query', getPaymentSignerInfoByPaymentId: Array<{ __typename?: 'PaymentStatusHistory', id: number, updatedBy: string, statusCode: Status, updatedDate: string }> };

export type GetTransferTemplateByCriteriaQueryVariables = Exact<{
  transferTemplateCriteria: TransferTemplateCriteriaInput;
}>;


export type GetTransferTemplateByCriteriaQuery = { __typename?: 'Query', getTransferTemplateByCriteria: Array<{ __typename?: 'TransferTemplates', id: number, createdDate: string, createdBy: string, legalPartyId: number, operations: Operations, nameTemplate: string, payerAccount: string, payerCurrency: string, payerBic: string | null, amount: number, recipientBic: string | null, recipientAccount: string, recipientName: string | null, recipientInn: string | null, paymentCode: string | null, categoryCode: string | null, purpose: string, commissionAccount: string | null, commissionCurrency: string | null, commissionOption: string | null, corrAccount: string | null, country: string | null, rubCodeVo: number | null, rubInn: string | null, kpp: string | null, kztBin: string | null, intermediaryBankBic: string | null, intermediaryCorrAccount: string | null, exoticAmount: number | null, exoticRate: number | null, exoticCurrency: string | null, isExotic: boolean | null, payerCardAccount: string | null, payerCardNum: string | null, payerCardType: string | null, recipientCardAccount: string | null, recipientCardNum: string | null, recipientCardType: string | null, recipientDetail: string | null, city: string | null, address: string | null }> };

export type GetSecondPersonTokenByPaymentIdsQueryVariables = Exact<{
  payments: PaymentIdListInput;
}>;


export type GetSecondPersonTokenByPaymentIdsQuery = { __typename?: 'Query', getSecondPersonTokenByPaymentIds: Array<{ __typename?: 'RecordTokens', id: number, token: string }> };

export type GetInterBankOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterBankOptionsQuery = { __typename?: 'Query', getAllOperation: Array<{ __typename?: 'Operation', id: number, operationCode: string, isActive: boolean }>, findAllCurrency: Array<{ __typename?: 'Currency', id: number | null, isoNum: string, isoCode: string }> };

export type GetSwiftOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSwiftOptionsQuery = { __typename?: 'Query', getAllCountry: Array<{ __typename?: 'Country', id: number, numInList: string, fullName: string }>, getAllOperation: Array<{ __typename?: 'Operation', id: number, operationCode: string, isActive: boolean }>, findAllCurrency: Array<{ __typename?: 'Currency', id: number | null, isoNum: string, isoCode: string }> };

export type GetRepeatableTransferOptionsQueryVariables = Exact<{
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankType: BankType;
  budgetClassificationCode: InputMaybe<Scalars['String']['input']>;
  pageable: PageInput;
}>;


export type GetRepeatableTransferOptionsQuery = { __typename?: 'Query', findBankByCodeCriteria: { __typename?: 'PaginatedBank', list: Array<{ __typename?: 'Banks', id: number, partyBankId: number | null, bankCode: string, bankName: string, corAccount: string | null, absBankCode: number | null, isActive: boolean }> }, findBudgetClassificationByCodeCriteria: { __typename?: 'PaginatedBudgetClassificationCode', list: Array<{ __typename?: 'BudgetClassificationCode', id: number, classCode: string, className: string, isActive: boolean }> } };

export type GetRepeatableSwiftOptionsQueryVariables = Exact<{
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankType: BankType;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  pageable: PageInput;
}>;


export type GetRepeatableSwiftOptionsQuery = { __typename?: 'Query', findBankByCodeCriteria: { __typename?: 'PaginatedBank', list: Array<{ __typename?: 'Banks', id: number, partyBankId: number | null, bankCode: string, bankName: string, corAccount: string | null, absBankCode: number | null, isActive: boolean }> }, findOperationTypeCategoryByCodeCriteria: { __typename?: 'PaginatedOperationTypeCategory', list: Array<{ __typename?: 'OperationTypeCategory', id: number, categoryCode: string, categoryName: string, isActive: boolean }> } };

export type GetNumberOfPayment4SignQueryVariables = Exact<{
  legalPartyIdInput: LegalPartyIdInput;
}>;


export type GetNumberOfPayment4SignQuery = { __typename?: 'Query', getNumberOfPayment4Sign: number };

export type GetCurrencyRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyRatesQuery = { __typename?: 'Query', getCurrencyRates: { __typename?: 'CurrencyRatesDto', cash: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, cashless: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, card: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, nbkr: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }> } };

export type GetCurrencyRatesConversionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyRatesConversionQuery = { __typename?: 'Query', getCurrencyRates: { __typename?: 'CurrencyRatesDto', cashless: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }>, nbkr: Array<{ __typename?: 'CurrencyRateDto', code: string, salesRate: number, purchaseRate: number }> } };

export type CalculateCommissionQueryVariables = Exact<{
  commissionInput: CommissionInput;
}>;


export type CalculateCommissionQuery = { __typename?: 'Query', calculateCommission: { __typename?: 'CommissionResponse', totalAmount: number, commissionAmount: number } };

export type CheckIsRefundAvailableQueryVariables = Exact<{
  refundIsAvailableInput: RefundIsAvailableInput;
}>;


export type CheckIsRefundAvailableQuery = { __typename?: 'Query', checkIsRefundAvailable: boolean };

export type GetQrOperationHistoryQueryVariables = Exact<{
  qrOperationFilterInput: QrOperationFilterInput;
  pageable: PageInput;
}>;


export type GetQrOperationHistoryQuery = { __typename?: 'Query', getQrOperationHistory: { __typename?: 'PaginatedQrOperationInfo', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrOperationInfo', id: string, createdDate: string, createdTime: string, amountWithFee: number, amountWithoutFee: number, origin: string, senderName: string | null, recipientName: string | null, account: string, feePercent: number, feeAmount: number, qrComment: string | null, stan: string, operationTypeGroup: OperationTypeGroup | null, qrAccount: string, salePointName: string | null, cashCode: string | null, providerTransactionId: string | null, description: string | null }> } };

export type GetQrOperationsLast2DaysQueryVariables = Exact<{
  filter: QrOperationLast2DaysFilter;
}>;


export type GetQrOperationsLast2DaysQuery = { __typename?: 'Query', getQrOperationsLast2Days: { __typename?: 'SaleQrOperationInfoLast2DaysDto', today: { __typename?: 'DailyQrOperationCountAndAmount', totalAmount: number, operationCount: number } | null, yesterday: { __typename?: 'DailyQrOperationCountAndAmount', totalAmount: number, operationCount: number } | null } };

export type FindAllQrTransferByFilterQueryVariables = Exact<{
  qrTransferFilter: QrTransferFilterInput;
  pageable: PageInput;
}>;


export type FindAllQrTransferByFilterQuery = { __typename?: 'Query', findAllQrTransferByFilter: { __typename?: 'PaginatedQrTransferRecordsByFilter', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrTransferRecordByFilter', transferNum: string, elqrTransferType: QrTransferType, qrTransferDirection: QrTransferDirection, createdDateTime: string, creatorName: string | null, payerAccount: string, recipientName: string | null, qrAccount: string | null, amount: number, status: Status, currencyCode: string, commission: number, commissionPercent: number, purpose: string | null, paymentId: number }> } };

export type FindSalaryDataByLegalPartyIdQueryVariables = Exact<{
  searchSalary: SearchSalary;
  pageable: PageInput;
}>;


export type FindSalaryDataByLegalPartyIdQuery = { __typename?: 'Query', findSalaryDataByLegalPartyId: { __typename?: 'PaginatedSalary', amountPages: number, amountElements: number, list: Array<{ __typename?: 'SalaryRecord', id: number, fileName: string, createdDate: string, paymentId: number, status: Status, totalAmount: number, currency: string, origin: Origin, fileId: number | null, isFullComplete: boolean | null }> } };

export type FindSalaryDetailBySalaryIdQueryVariables = Exact<{
  salaryId: SalaryIdInput;
  pageable: PageInput;
}>;


export type FindSalaryDetailBySalaryIdQuery = { __typename?: 'Query', findSalaryDetailBySalaryId: { __typename?: 'SalaryInfoWithDetail', paymentId: number, salaryId: number, fileName: string, totalAmount: number, status: Status, createdDate: string, creatorName: string, valueDate: string, account: string, origin: Origin, fileId: number | null, companyName: string, currency: { __typename?: 'Currency', isoCode: string }, salaryDetailResponse: { __typename?: 'PaginatedSalaryDetail', amountElements: number, amountPages: number, list: Array<{ __typename?: 'SalaryDetailResponse', id: number, fullName: string, cardAccount: string, amount: number, state: boolean | null }> } } };

export type FindSalaryDetailBySalaryIdForSignQueryVariables = Exact<{
  salaryId: SalaryIdInput;
  pageable: PageInput;
}>;


export type FindSalaryDetailBySalaryIdForSignQuery = { __typename?: 'Query', findSalaryDetailBySalaryId: { __typename?: 'SalaryInfoWithDetail', paymentId: number, salaryId: number, fileName: string, totalAmount: number, createdDate: string, valueDate: string, account: string, companyName: string, origin: Origin, fileId: number | null, currency: { __typename?: 'Currency', isoCode: string }, salaryDetailResponse: { __typename?: 'PaginatedSalaryDetail', amountElements: number } } };

export type GetQrOperationInstallmentQueryVariables = Exact<{
  filter: QrOperationInstallmentFilterInput;
  pageable: PageInput;
}>;


export type GetQrOperationInstallmentQuery = { __typename?: 'Query', getQrOperationInstallment: { __typename?: 'PaginatedQrOperationInfo', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrOperationInfo', id: string, amountWithFee: number, createdDate: string, senderName: string | null, stan: string, salePointName: string | null, operationType: string | null, qrOperationStatus: string | null }> } };

export type GetTotalSumInstallmentQueryVariables = Exact<{
  filter: QrOperationInstallmentFilterInput;
}>;


export type GetTotalSumInstallmentQuery = { __typename?: 'Query', getTotalSumInstallment: number };

export type GetInvoiceStatusAmountsQueryVariables = Exact<{
  legalPartyIdInvoiceId: LegalPartyIdInvoiceIdDto;
}>;


export type GetInvoiceStatusAmountsQuery = { __typename?: 'Query', getInvoiceStatusAmounts: Array<{ __typename?: 'AmountStatusDto', statusCode: Status, amount: number }> };

export type FindPaymentsByInvoiceIdsQueryVariables = Exact<{
  legalPartyIdInvoiceId: LegalPartyIdInvoiceIdDto;
  pageable: PageInput;
}>;


export type FindPaymentsByInvoiceIdsQuery = { __typename?: 'Query', findPaymentsByInvoiceIds: { __typename?: 'PaginatedTransferByInvoiceDto', amountPages: number, amountElements: number, currentPage: number, list: Array<{ __typename?: 'TransferByInvoiceDto', amount: number, creatorName: string, isoCode: string, invoiceId: number, paymentId: number, statusCode: Status }> } };

export type FindTransferByInvoiceDetailByIdQueryVariables = Exact<{
  paymentIdInput: PaymentIdInput;
}>;


export type FindTransferByInvoiceDetailByIdQuery = { __typename?: 'Query', findTransferByInvoiceDetailById: { __typename?: 'TransferByInvoiceDetailDto', amount: number, creatorName: string, invoiceId: number, isoCode: string, legalPartyId: number, payerAccount: string, paymentId: number, purpose: string, recipientAccount: string, recipientName: string, statusCode: Status, valueDate: any, createdBy: string, createdDate: string, transferNum: string } };

export type GetPersonalQrOperationHistoryWithPaginationQueryVariables = Exact<{
  personalQrOperationFilterInput: PersonalQrOperationFilterInput;
  pageable: PageInput;
}>;


export type GetPersonalQrOperationHistoryWithPaginationQuery = { __typename?: 'Query', getPersonalQrOperationHistoryWithPagination: { __typename?: 'PaginatedQrOperationInfo', currentPage: number, amountPages: number, amountElements: number, list: Array<{ __typename?: 'QrOperationInfo', id: string, createdDate: string, createdTime: string, amountWithFee: number, amountWithoutFee: number, origin: string, senderName: string | null, recipientName: string | null, account: string, feePercent: number, feeAmount: number, qrComment: string | null, stan: string, operationTypeGroup: OperationTypeGroup | null, qrAccount: string, salePointName: string | null, cashCode: string | null, providerTransactionId: string | null, description: string | null }> } };

export type ListenPaymentSubscriptionVariables = Exact<{
  legalPartyIdAndPaymentId: LegalPartyIdAndPaymentIdInput;
}>;


export type ListenPaymentSubscription = { __typename?: 'Subscription', listenPayment: { __typename?: 'HistoryPayment', state: PaymentSubscriptionStateEnum, paymentInformation: { __typename?: 'OperationHistoryByCriteria', id: number, createdDate: string, createdBy: string, updatedBy: string, recipientAccount: string, operationCode: Operations, transferNum: string, valueDate: string, payerAccount: string, amount: number, currency: string, statusCode: Status, purpose: string, recipientName: string, legalPartyId: number, paymentDetailsId: number, description: string, origin: Origin } } };

export type ListenSalarySubscriptionVariables = Exact<{
  salaryIdInput: SalaryIdInput;
}>;


export type ListenSalarySubscription = { __typename?: 'Subscription', listenSalary: { __typename?: 'SalarySubscriptionDto', state: PaymentSubscriptionStateEnum, salaryResponseDto: { __typename?: 'SalaryRecord', id: number, fileName: string, createdDate: string, paymentId: number, status: Status, totalAmount: number, currency: string, origin: Origin, fileId: number | null, isFullComplete: boolean | null } } };

export const CurrencyForPaymentFragmentDoc = gql`
    fragment CurrencyForPayment on Currency {
  id
  isoNum
  isoCode
}
    `;
export const BankFragmentDoc = gql`
    fragment Bank on Banks {
  id
  partyBankId
  bankCode
  bankName
  corAccount
  absBankCode
  isActive
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  numInList
  fullName
}
    `;
export const OperationFragmentDoc = gql`
    fragment Operation on Operation {
  id
  operationCode
  isActive
}
    `;
export const BudgetClassificationCodeFragmentDoc = gql`
    fragment BudgetClassificationCode on BudgetClassificationCode {
  id
  classCode
  className
  isActive
}
    `;
export const OperationTypeCategoryFragmentDoc = gql`
    fragment OperationTypeCategory on OperationTypeCategory {
  id
  categoryCode
  categoryName
  isActive
}
    `;
export const OperationHistoryByCriteriaFragmentDoc = gql`
    fragment OperationHistoryByCriteria on OperationHistoryByCriteria {
  id
  createdDate
  createdBy
  updatedBy
  recipientAccount
  operationCode
  transferNum
  valueDate
  payerAccount
  amount
  currency
  statusCode
  purpose
  recipientName
  legalPartyId
  paymentDetailsId
  description
  origin
}
    `;
export const PaginatedOperationHistoryByCriteriaFragmentDoc = gql`
    fragment PaginatedOperationHistoryByCriteria on PaginatedOperationHistoryByCriteria {
  list {
    ...OperationHistoryByCriteria
  }
  amountPages
  amountElements
  currentPage
}
    ${OperationHistoryByCriteriaFragmentDoc}`;
export const TransferPaymentRecordFragmentDoc = gql`
    fragment TransferPaymentRecord on TransferPaymentRecord {
  id
  createdDate
  createdBy
  updatedBy
  legalPartyId
  operationCode
  description
  amount
  currencyId
  currencyCode
  payerAccount
  payerBic
  payerBicName
  payerInn
  payerName
  paymentCode
  purpose
  recipientAccount
  recipientBic
  recipientBicName
  recipientInn
  recipientName
  transferNum
  valueDate
  statusCode
  creatorName
  origin
}
    `;
export const ConversionPaymentRecordFragmentDoc = gql`
    fragment ConversionPaymentRecord on ConversionPaymentRecord {
  id
  createdDate
  createdBy
  updatedBy
  legalPartyId
  operationCode
  description
  amount
  recipientAmount
  rate
  currencyId
  currencyCode
  payerAccount
  payerBic
  payerBicName
  payerName
  recipientAccount
  transferNum
  valueDate
  statusCode
  recipientCurrencyCode
  recipientCurrencyId
  isFixedRate
  creatorName
}
    `;
export const SwiftPaymentRecordFragmentDoc = gql`
    fragment SwiftPaymentRecord on SwiftPaymentRecord {
  id
  createdDate
  createdBy
  updatedBy
  legalPartyId
  operationCode
  transferNum
  valueDate
  payerName
  payerAccount
  currencyId
  currencyCode
  amount
  recipientName
  recipientAccount
  recipientBankCode
  recipientBankName
  purpose
  commissionAccount
  commissionOption
  commissionCurrencyId
  commissionCurrencyCode
  rubInn
  categoryId
  categoryCode
  corrAccount
  kpp
  country
  rubCodeVo
  kztBin
  statusCode
  description
  intermediaryBankCode
  isExotic
  exoticAmount
  exoticCurrencyCode
  exoticRate
  creatorName
  origin
  city
  address
}
    `;
export const CardTransferRecordFragmentDoc = gql`
    fragment CardTransferRecord on CardTransferRecord {
  id
  createdDate
  statusCode
  amount
  currencyId
  currencyCode
  operationCode
  purpose
  valueDate
  transferNum
  paymentCode
  createdBy
  creatorName
  recipientName
  recipientCardNum
  recipientAccount
  recipientCurrencyCode
  recipientInn
  recipientBic
  recipientBicName
  recipientDetail
  cardReferencesId
  legalPartyId
  description
  payerName
  payerAccount
  origin
}
    `;
export const BudgetPaymentRecordFragmentDoc = gql`
    fragment BudgetPaymentRecord on BudgetPaymentRecord {
  id
  createdDate
  createdBy
  creatorName
  updatedBy
  legalPartyId
  description
  operationCode
  transferNum
  valueDate
  recipientAccount
  payerAccount
  statusCode
  paymentCode
  amount
  commission
  paylogicId
  purpose
  currency
}
    `;
export const TransferByInvoiceDetailFragmentDoc = gql`
    fragment TransferByInvoiceDetail on TransferByInvoiceDetailDto {
  amount
  creatorName
  invoiceId
  isoCode
  legalPartyId
  payerAccount
  paymentId
  purpose
  recipientAccount
  recipientName
  statusCode
  valueDate
  createdBy
  createdDate
  transferNum
}
    `;
export const RefundedQrOperationRecordFragmentDoc = gql`
    fragment RefundedQrOperationRecord on QrRefundedOperationInfo {
  cardTransferRko2CardRecord {
    id
    createdDate
    statusCode
    amount
    currencyCode
    operationCode
    purpose
    creatorName
    recipientName
    recipientCardNum
    recipientAccount
    recipientBic
    recipientBicName
    description
    payerName
    payerAccount
    recipientDetail
  }
  salePointDto {
    salePointName
  }
}
    `;
export const PaymentStatusHistoryFragmentDoc = gql`
    fragment PaymentStatusHistory on PaymentStatusHistory {
  id
  updatedBy
  statusCode
  updatedDate
}
    `;
export const TransferTemplateFragmentDoc = gql`
    fragment TransferTemplate on TransferTemplates {
  id
  createdDate
  createdBy
  legalPartyId
  operations
  nameTemplate
  payerAccount
  payerCurrency
  payerBic
  amount
  recipientBic
  recipientAccount
  recipientName
  recipientInn
  paymentCode
  categoryCode
  purpose
  commissionAccount
  commissionCurrency
  commissionOption
  corrAccount
  country
  rubCodeVo
  rubInn
  kpp
  kztBin
  intermediaryBankBic
  intermediaryCorrAccount
  exoticAmount
  exoticRate
  exoticCurrency
  isExotic
  payerCardAccount
  payerCardNum
  payerCardType
  recipientCardAccount
  recipientCardNum
  recipientCardType
  recipientDetail
  city
  address
}
    `;
export const HistoryPaymentFragmentDoc = gql`
    fragment HistoryPayment on HistoryPayment {
  paymentInformation {
    ...OperationHistoryByCriteria
  }
  state
}
    ${OperationHistoryByCriteriaFragmentDoc}`;
export const RecordTokensFragmentDoc = gql`
    fragment RecordTokens on RecordTokens {
  id
  token
}
    `;
export const RecordPaymentsFragmentDoc = gql`
    fragment RecordPayments on RecordPayments {
  status
  id
}
    `;
export const CurrencyRateFragmentDoc = gql`
    fragment CurrencyRate on CurrencyRateDto {
  code
  salesRate
  purchaseRate
}
    `;
export const CurrencyRatesFragmentDoc = gql`
    fragment CurrencyRates on CurrencyRatesDto {
  cash {
    ...CurrencyRate
  }
  cashless {
    ...CurrencyRate
  }
  card {
    ...CurrencyRate
  }
  nbkr {
    ...CurrencyRate
  }
}
    ${CurrencyRateFragmentDoc}`;
export const CurrencyRatesConversionFragmentDoc = gql`
    fragment CurrencyRatesConversion on CurrencyRatesDto {
  cashless {
    ...CurrencyRate
  }
  nbkr {
    ...CurrencyRate
  }
}
    ${CurrencyRateFragmentDoc}`;
export const PaymentCommissionFragmentDoc = gql`
    fragment PaymentCommission on CommissionResponse {
  totalAmount
  commissionAmount
}
    `;
export const CardTransferRko2CardRecordFragmentDoc = gql`
    fragment CardTransferRko2CardRecord on CardTransferRecord {
  id
  createdDate
  statusCode
  amount
  currencyId
  currencyCode
  operationCode
  purpose
  valueDate
  transferNum
  paymentCode
  createdBy
  creatorName
  recipientName
  recipientAccount
  recipientCardNum
  recipientCurrencyCode
  recipientInn
  recipientBic
  recipientBicName
  recipientDetail
  cardReferencesId
  legalPartyId
  description
  payerName
  payerAccount
  origin
}
    `;
export const QrOperationInfoFragmentDoc = gql`
    fragment QrOperationInfo on QrOperationInfo {
  id
  createdDate
  createdTime
  amountWithFee
  amountWithoutFee
  origin
  senderName
  recipientName
  account
  feePercent
  feeAmount
  qrComment
  stan
  operationTypeGroup
  qrAccount
  salePointName
  cashCode
  providerTransactionId
  description
}
    `;
export const QrOperationPaginatedFragmentDoc = gql`
    fragment QrOperationPaginated on PaginatedQrOperationInfo {
  list {
    ...QrOperationInfo
  }
  currentPage
  amountPages
  amountElements
}
    ${QrOperationInfoFragmentDoc}`;
export const DailyQrOperationCountAndAmountFragmentDoc = gql`
    fragment DailyQrOperationCountAndAmount on DailyQrOperationCountAndAmount {
  totalAmount
  operationCount
}
    `;
export const SaleQrOperationInfoLast2DaysFragmentDoc = gql`
    fragment SaleQrOperationInfoLast2Days on SaleQrOperationInfoLast2DaysDto {
  today {
    ...DailyQrOperationCountAndAmount
  }
  yesterday {
    ...DailyQrOperationCountAndAmount
  }
}
    ${DailyQrOperationCountAndAmountFragmentDoc}`;
export const QrTransferRecordFragmentDoc = gql`
    fragment QrTransferRecord on QrTransferRecordById {
  createdDateTime
  statusCode
  amount
  currencyCode
  purpose
  transferNum
  creatorName
  commission
  commissionPercent
  legalPartyId
  paymentId
  recipientName
  description
}
    `;
export const QrTransferHistoryRecordFragmentDoc = gql`
    fragment QrTransferHistoryRecord on QrTransferRecordByFilter {
  transferNum
  elqrTransferType
  qrTransferDirection
  createdDateTime
  creatorName
  payerAccount
  recipientName
  qrAccount
  amount
  status
  currencyCode
  commission
  commissionPercent
  purpose
  paymentId
}
    `;
export const PaginatedQrTransferHistoryRecordsFragmentDoc = gql`
    fragment PaginatedQrTransferHistoryRecords on PaginatedQrTransferRecordsByFilter {
  list {
    ...QrTransferHistoryRecord
  }
  currentPage
  amountPages
  amountElements
}
    ${QrTransferHistoryRecordFragmentDoc}`;
export const SalaryRecordFragmentDoc = gql`
    fragment SalaryRecord on SalaryRecord {
  id
  fileName
  createdDate
  paymentId
  status
  totalAmount
  currency
  origin
  fileId
  isFullComplete
}
    `;
export const PaginatedSalaryFragmentDoc = gql`
    fragment PaginatedSalary on PaginatedSalary {
  list {
    ...SalaryRecord
  }
  amountPages
  amountElements
}
    ${SalaryRecordFragmentDoc}`;
export const SalaryDetailResponseFragmentDoc = gql`
    fragment SalaryDetailResponse on SalaryDetailResponse {
  id
  fullName
  cardAccount
  amount
  state
}
    `;
export const PaginatedSalaryDetailFragmentDoc = gql`
    fragment PaginatedSalaryDetail on PaginatedSalaryDetail {
  amountElements
  amountPages
  list {
    ...SalaryDetailResponse
  }
}
    ${SalaryDetailResponseFragmentDoc}`;
export const SalaryInfoWithDetailFragmentDoc = gql`
    fragment SalaryInfoWithDetail on SalaryInfoWithDetail {
  paymentId
  salaryId
  fileName
  totalAmount
  status
  createdDate
  creatorName
  valueDate
  account
  origin
  fileId
  companyName
  currency {
    isoCode
  }
  salaryDetailResponse {
    ...PaginatedSalaryDetail
  }
}
    ${PaginatedSalaryDetailFragmentDoc}`;
export const SalaryInfoWithDetailForSignFragmentDoc = gql`
    fragment SalaryInfoWithDetailForSign on SalaryInfoWithDetail {
  paymentId
  salaryId
  fileName
  totalAmount
  createdDate
  valueDate
  account
  companyName
  origin
  fileId
  currency {
    isoCode
  }
  salaryDetailResponse {
    amountElements
  }
}
    `;
export const SalarySubscriptionFragmentDoc = gql`
    fragment SalarySubscription on SalarySubscriptionDto {
  state
  salaryResponseDto {
    ...SalaryRecord
  }
}
    ${SalaryRecordFragmentDoc}`;
export const QrOperationInfoInstallmentFragmentDoc = gql`
    fragment QrOperationInfoInstallment on QrOperationInfo {
  id
  amountWithFee
  createdDate
  senderName
  stan
  salePointName
  operationType
  qrOperationStatus
}
    `;
export const PaginatedQrOperationInfoFragmentDoc = gql`
    fragment PaginatedQrOperationInfo on PaginatedQrOperationInfo {
  list {
    ...QrOperationInfoInstallment
  }
  currentPage
  amountPages
  amountElements
}
    ${QrOperationInfoInstallmentFragmentDoc}`;
export const PersonalQrOperationInfoFragmentDoc = gql`
    fragment PersonalQrOperationInfo on QrOperationInfo {
  id
  createdDate
  createdTime
  amountWithFee
  amountWithoutFee
  origin
  senderName
  recipientName
  account
  feePercent
  feeAmount
  qrComment
  stan
  operationTypeGroup
  qrAccount
  salePointName
  cashCode
  providerTransactionId
  description
}
    `;
export const PersonalQrOperationPaginatedFragmentDoc = gql`
    fragment PersonalQrOperationPaginated on PaginatedQrOperationInfo {
  list {
    ...PersonalQrOperationInfo
  }
  currentPage
  amountPages
  amountElements
}
    ${PersonalQrOperationInfoFragmentDoc}`;
export const UpdatePaymentDocument = gql`
    mutation updatePayment($updatePayment: UpdatePayment!) {
  updatePayment(updatePayment: $updatePayment) {
    id
  }
}
    `;
export const SaveInterBankTransferNativeDraftDocument = gql`
    mutation saveInterBankTransferNativeDraft($interBankTransfer: TransferInput!) {
  saveInterBankTransferNativeDraft(interBankTransfer: $interBankTransfer) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveIntraBankOwnerTransferDraftDocument = gql`
    mutation saveIntraBankOwnerTransferDraft($intraTransfer: TransferInput!) {
  saveIntraBankOwnerTransferDraft(intraTransfer: $intraTransfer) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveCardTransferDocument = gql`
    mutation saveCardTransfer($cardTransfer: CardTransferInput!) {
  saveCardTransfer(cardTransfer: $cardTransfer) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveIntraBankForeignTransferDraftDocument = gql`
    mutation saveIntraBankForeignTransferDraft($intraTransfer: TransferInput!) {
  saveIntraBankForeignTransferDraft(intraTransfer: $intraTransfer) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveConversionDraftDocument = gql`
    mutation saveConversionDraft($conversion: ConversionInput!) {
  saveConversionDraft(conversion: $conversion) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveSwiftDocument = gql`
    mutation saveSwift($swift: SwiftInput!) {
  saveSwift(swift: $swift) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SigningPaymentDocument = gql`
    mutation signingPayment($sign: SignatureInput!) {
  signingPayment(sign: $sign) {
    ...RecordPayments
  }
}
    ${RecordPaymentsFragmentDoc}`;
export const DeletePaymentDocument = gql`
    mutation deletePayment($payment: PaymentIdInput!) {
  deletePayment(payment: $payment) {
    id
  }
}
    `;
export const ForSigningPaymentDocument = gql`
    mutation forSigningPayment($payment: PaymentIdListInput!) {
  forSigningPayment(payment: $payment) {
    id
    status
  }
}
    `;
export const SaveTransferTemplateDocument = gql`
    mutation saveTransferTemplate($template: TransferTemplateInput!) {
  saveTransferTemplate(template: $template)
}
    `;
export const UpdateTemplateDocument = gql`
    mutation updateTemplate($template: TemplateInput) {
  updateTemplate(template: $template)
}
    `;
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($template: TemplateIdInput!) {
  deleteTemplate(template: $template)
}
    `;
export const RecallPaymentDocument = gql`
    mutation recallPayment($paymentIdListInput: PaymentIdListInput!) {
  recallPayment(paymentIdListInput: $paymentIdListInput) {
    id
    status
  }
}
    `;
export const SaveBudgetPaymentDocument = gql`
    mutation saveBudgetPayment($budgetPayment: BudgetPaymentInput!) {
  saveBudgetPayment(budgetPayment: $budgetPayment) {
    paymentId
    pcTransactionId
  }
}
    `;
export const RefundOperationDocument = gql`
    mutation refundOperation($refundInput: RefundInput!) {
  refundOperation(refundInput: $refundInput) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveQrTransferDocument = gql`
    mutation saveQrTransfer($qrTransferInput: QrTransferInput!) {
  saveQrTransfer(qrTransferInput: $qrTransferInput) {
    paymentId
    pcTransactionId
  }
}
    `;
export const SaveSalaryDocument = gql`
    mutation saveSalary($salaryRequest: SalaryRequest!) {
  saveSalary(salaryRequest: $salaryRequest) {
    id
  }
}
    `;
export const SigningSalaryDocument = gql`
    mutation signingSalary($sign: SignatureSalaryInput!) {
  signingSalary(sign: $sign) {
    id
    status
  }
}
    `;
export const GetAllOperationDocument = gql`
    query getAllOperation {
  getAllOperation {
    ...Operation
  }
}
    ${OperationFragmentDoc}`;
export const GetAllCountryDocument = gql`
    query getAllCountry {
  getAllCountry {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export const GetModelProcessDocument = gql`
    query getModelProcess($payment: PaymentIdInput!) {
  getModelProcess(payment: $payment)
}
    `;
export const GetBanksByCodeDocument = gql`
    query getBanksByCode($bankCode: String, $bankType: BankType!, $pageable: PageInput!) {
  findBankByCodeCriteria(
    bankCode: $bankCode
    bankType: $bankType
    pageable: $pageable
  ) {
    list {
      ...Bank
    }
    amountPages
    amountElements
  }
}
    ${BankFragmentDoc}`;
export const GetBudgetClassificationsByCodeDocument = gql`
    query getBudgetClassificationsByCode($budgetClassificationCode: String, $pageable: PageInput!) {
  findBudgetClassificationByCodeCriteria(
    budgetClassificationCode: $budgetClassificationCode
    pageable: $pageable
  ) {
    list {
      ...BudgetClassificationCode
    }
    amountPages
    amountElements
  }
}
    ${BudgetClassificationCodeFragmentDoc}`;
export const GetOperationTypeCategoryByCodeDocument = gql`
    query getOperationTypeCategoryByCode($operationTypeCode: String, $pageable: PageInput!) {
  findOperationTypeCategoryByCodeCriteria(
    operationTypeCode: $operationTypeCode
    pageable: $pageable
  ) {
    list {
      ...OperationTypeCategory
    }
    amountPages
    amountElements
  }
}
    ${OperationTypeCategoryFragmentDoc}`;
export const SearchPaymentByCriteriaDocument = gql`
    query searchPaymentByCriteria($searchOperationHistory: SearchOperationHistoryInput!, $pageable: PageInput!) {
  searchPaymentByCriteria(
    searchOperationHistory: $searchOperationHistory
    pageable: $pageable
  ) {
    list {
      ...OperationHistoryByCriteria
    }
    amountPages
    amountElements
    currentPage
  }
}
    ${OperationHistoryByCriteriaFragmentDoc}`;
export const FindTransferDataByPaymentIdDocument = gql`
    query findTransferDataByPaymentId($payment: PaymentIdInput!) {
  findTransferDataByPaymentId(payment: $payment) {
    ...TransferPaymentRecord
  }
}
    ${TransferPaymentRecordFragmentDoc}`;
export const FindConversionDataByPaymentIdDocument = gql`
    query findConversionDataByPaymentId($payment: PaymentIdInput!) {
  findConversionDataByPaymentId(payment: $payment) {
    ...ConversionPaymentRecord
  }
}
    ${ConversionPaymentRecordFragmentDoc}`;
export const FindCardTransferDataByPaymentIdDocument = gql`
    query findCardTransferDataByPaymentId($payment: PaymentIdInput!) {
  findCardTransferDataByPaymentId(payment: $payment) {
    ...CardTransferRecord
  }
}
    ${CardTransferRecordFragmentDoc}`;
export const FindRefundedQrOperationInfoDocument = gql`
    query findRefundedQrOperationInfo($payment: PaymentIdInput!) {
  findRefundedQrOperationInfo(payment: $payment) {
    ...RefundedQrOperationRecord
  }
}
    ${RefundedQrOperationRecordFragmentDoc}`;
export const FindQrTransferDataByPaymentIdDocument = gql`
    query findQrTransferDataByPaymentId($payment: PaymentIdInput!) {
  findQrTransferDataByPaymentId(payment: $payment) {
    ...QrTransferRecord
  }
}
    ${QrTransferRecordFragmentDoc}`;
export const FindBudgetPaymentDataByPaymentIdDocument = gql`
    query findBudgetPaymentDataByPaymentId($payment: PaymentIdInput!) {
  findBudgetPaymentDataByPaymentId(payment: $payment) {
    ...BudgetPaymentRecord
  }
}
    ${BudgetPaymentRecordFragmentDoc}`;
export const CalculateExoticAmountInSwiftDocument = gql`
    query calculateExoticAmountInSwift($calculateAmount: CalculateExoticAmountInput!) {
  calculateExoticAmountInSwift(calculateAmount: $calculateAmount)
}
    `;
export const FindAllCurrencyDocument = gql`
    query findAllCurrency {
  findAllCurrency {
    ...CurrencyForPayment
  }
}
    ${CurrencyForPaymentFragmentDoc}`;
export const FindSwiftDataByPaymentIdDocument = gql`
    query findSwiftDataByPaymentId($payment: PaymentIdInput!) {
  findSwiftDataByPaymentId(payment: $payment) {
    ...SwiftPaymentRecord
  }
}
    ${SwiftPaymentRecordFragmentDoc}`;
export const GetPaymentStatusHistoryByPaymentIdDocument = gql`
    query getPaymentStatusHistoryByPaymentId($payment: PaymentIdInput!) {
  getPaymentStatusHistoryByPaymentId(payment: $payment) {
    ...PaymentStatusHistory
  }
}
    ${PaymentStatusHistoryFragmentDoc}`;
export const GetPaymentSignerInfoByPaymentIdDocument = gql`
    query getPaymentSignerInfoByPaymentId($payment: PaymentIdInput!) {
  getPaymentSignerInfoByPaymentId(payment: $payment) {
    ...PaymentStatusHistory
  }
}
    ${PaymentStatusHistoryFragmentDoc}`;
export const GetTransferTemplateByCriteriaDocument = gql`
    query getTransferTemplateByCriteria($transferTemplateCriteria: TransferTemplateCriteriaInput!) {
  getTransferTemplateByCriteria(
    transferTemplateCriteria: $transferTemplateCriteria
  ) {
    ...TransferTemplate
  }
}
    ${TransferTemplateFragmentDoc}`;
export const GetSecondPersonTokenByPaymentIdsDocument = gql`
    query getSecondPersonTokenByPaymentIds($payments: PaymentIdListInput!) {
  getSecondPersonTokenByPaymentIds(payments: $payments) {
    ...RecordTokens
  }
}
    ${RecordTokensFragmentDoc}`;
export const GetInterBankOptionsDocument = gql`
    query getInterBankOptions {
  getAllOperation {
    ...Operation
  }
  findAllCurrency {
    ...CurrencyForPayment
  }
}
    ${OperationFragmentDoc}
${CurrencyForPaymentFragmentDoc}`;
export const GetSwiftOptionsDocument = gql`
    query getSwiftOptions {
  getAllCountry {
    ...Country
  }
  getAllOperation {
    ...Operation
  }
  findAllCurrency {
    ...CurrencyForPayment
  }
}
    ${CountryFragmentDoc}
${OperationFragmentDoc}
${CurrencyForPaymentFragmentDoc}`;
export const GetRepeatableTransferOptionsDocument = gql`
    query getRepeatableTransferOptions($bankCode: String, $bankType: BankType!, $budgetClassificationCode: String, $pageable: PageInput!) {
  findBankByCodeCriteria(
    bankCode: $bankCode
    bankType: $bankType
    pageable: $pageable
  ) {
    list {
      ...Bank
    }
  }
  findBudgetClassificationByCodeCriteria(
    budgetClassificationCode: $budgetClassificationCode
    pageable: $pageable
  ) {
    list {
      ...BudgetClassificationCode
    }
  }
}
    ${BankFragmentDoc}
${BudgetClassificationCodeFragmentDoc}`;
export const GetRepeatableSwiftOptionsDocument = gql`
    query getRepeatableSwiftOptions($bankCode: String, $bankType: BankType!, $categoryCode: String, $pageable: PageInput!) {
  findBankByCodeCriteria(
    bankCode: $bankCode
    bankType: $bankType
    pageable: $pageable
  ) {
    list {
      ...Bank
    }
  }
  findOperationTypeCategoryByCodeCriteria(
    operationTypeCode: $categoryCode
    pageable: $pageable
  ) {
    list {
      ...OperationTypeCategory
    }
  }
}
    ${BankFragmentDoc}
${OperationTypeCategoryFragmentDoc}`;
export const GetNumberOfPayment4SignDocument = gql`
    query getNumberOfPayment4Sign($legalPartyIdInput: LegalPartyIdInput!) {
  getNumberOfPayment4Sign(legalPartyIdInput: $legalPartyIdInput)
}
    `;
export const GetCurrencyRatesDocument = gql`
    query getCurrencyRates {
  getCurrencyRates {
    ...CurrencyRates
  }
}
    ${CurrencyRatesFragmentDoc}`;
export const GetCurrencyRatesConversionDocument = gql`
    query getCurrencyRatesConversion {
  getCurrencyRates {
    ...CurrencyRatesConversion
  }
}
    ${CurrencyRatesConversionFragmentDoc}`;
export const CalculateCommissionDocument = gql`
    query calculateCommission($commissionInput: CommissionInput!) {
  calculateCommission(commissionInput: $commissionInput) {
    ...PaymentCommission
  }
}
    ${PaymentCommissionFragmentDoc}`;
export const CheckIsRefundAvailableDocument = gql`
    query checkIsRefundAvailable($refundIsAvailableInput: RefundIsAvailableInput!) {
  checkIsRefundAvailable(refundIsAvailableInput: $refundIsAvailableInput)
}
    `;
export const GetQrOperationHistoryDocument = gql`
    query getQrOperationHistory($qrOperationFilterInput: QrOperationFilterInput!, $pageable: PageInput!) {
  getQrOperationHistory(
    qrOperationFilterInput: $qrOperationFilterInput
    pageable: $pageable
  ) {
    ...QrOperationPaginated
  }
}
    ${QrOperationPaginatedFragmentDoc}`;
export const GetQrOperationsLast2DaysDocument = gql`
    query getQrOperationsLast2Days($filter: QrOperationLast2DaysFilter!) {
  getQrOperationsLast2Days(filter: $filter) {
    ...SaleQrOperationInfoLast2Days
  }
}
    ${SaleQrOperationInfoLast2DaysFragmentDoc}`;
export const FindAllQrTransferByFilterDocument = gql`
    query findAllQrTransferByFilter($qrTransferFilter: QrTransferFilterInput!, $pageable: PageInput!) {
  findAllQrTransferByFilter(
    qrTransferFilter: $qrTransferFilter
    pageable: $pageable
  ) {
    ...PaginatedQrTransferHistoryRecords
  }
}
    ${PaginatedQrTransferHistoryRecordsFragmentDoc}`;
export const FindSalaryDataByLegalPartyIdDocument = gql`
    query findSalaryDataByLegalPartyId($searchSalary: SearchSalary!, $pageable: PageInput!) {
  findSalaryDataByLegalPartyId(searchSalary: $searchSalary, pageable: $pageable) {
    ...PaginatedSalary
  }
}
    ${PaginatedSalaryFragmentDoc}`;
export const FindSalaryDetailBySalaryIdDocument = gql`
    query findSalaryDetailBySalaryId($salaryId: SalaryIdInput!, $pageable: PageInput!) {
  findSalaryDetailBySalaryId(salaryId: $salaryId, pageable: $pageable) {
    ...SalaryInfoWithDetail
  }
}
    ${SalaryInfoWithDetailFragmentDoc}`;
export const FindSalaryDetailBySalaryIdForSignDocument = gql`
    query findSalaryDetailBySalaryIdForSign($salaryId: SalaryIdInput!, $pageable: PageInput!) {
  findSalaryDetailBySalaryId(salaryId: $salaryId, pageable: $pageable) {
    ...SalaryInfoWithDetailForSign
  }
}
    ${SalaryInfoWithDetailForSignFragmentDoc}`;
export const GetQrOperationInstallmentDocument = gql`
    query getQrOperationInstallment($filter: QrOperationInstallmentFilterInput!, $pageable: PageInput!) {
  getQrOperationInstallment(filter: $filter, pageable: $pageable) {
    ...PaginatedQrOperationInfo
  }
}
    ${PaginatedQrOperationInfoFragmentDoc}`;
export const GetTotalSumInstallmentDocument = gql`
    query getTotalSumInstallment($filter: QrOperationInstallmentFilterInput!) {
  getTotalSumInstallment(filter: $filter)
}
    `;
export const GetInvoiceStatusAmountsDocument = gql`
    query getInvoiceStatusAmounts($legalPartyIdInvoiceId: LegalPartyIdInvoiceIdDto!) {
  getInvoiceStatusAmounts(legalPartyIdInvoiceId: $legalPartyIdInvoiceId) {
    statusCode
    amount
  }
}
    `;
export const FindPaymentsByInvoiceIdsDocument = gql`
    query findPaymentsByInvoiceIds($legalPartyIdInvoiceId: LegalPartyIdInvoiceIdDto!, $pageable: PageInput!) {
  findPaymentsByInvoiceIds(
    legalPartyIdInvoiceId: $legalPartyIdInvoiceId
    pageable: $pageable
  ) {
    list {
      amount
      creatorName
      isoCode
      invoiceId
      paymentId
      statusCode
    }
    amountPages
    amountElements
    currentPage
  }
}
    `;
export const FindTransferByInvoiceDetailByIdDocument = gql`
    query findTransferByInvoiceDetailById($paymentIdInput: PaymentIdInput!) {
  findTransferByInvoiceDetailById(paymentIdInput: $paymentIdInput) {
    ...TransferByInvoiceDetail
  }
}
    ${TransferByInvoiceDetailFragmentDoc}`;
export const GetPersonalQrOperationHistoryWithPaginationDocument = gql`
    query getPersonalQrOperationHistoryWithPagination($personalQrOperationFilterInput: PersonalQrOperationFilterInput!, $pageable: PageInput!) {
  getPersonalQrOperationHistoryWithPagination(
    personalQrOperationFilterInput: $personalQrOperationFilterInput
    pageable: $pageable
  ) {
    ...PersonalQrOperationPaginated
  }
}
    ${PersonalQrOperationPaginatedFragmentDoc}`;
export const ListenPaymentDocument = gql`
    subscription listenPayment($legalPartyIdAndPaymentId: LegalPartyIdAndPaymentIdInput!) {
  listenPayment(legalPartyIdAndPaymentId: $legalPartyIdAndPaymentId) {
    ...HistoryPayment
  }
}
    ${HistoryPaymentFragmentDoc}`;
export const ListenSalaryDocument = gql`
    subscription listenSalary($salaryIdInput: SalaryIdInput!) {
  listenSalary(salaryIdInput: $salaryIdInput) {
    ...SalarySubscription
  }
}
    ${SalarySubscriptionFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    updatePayment(variables: UpdatePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentMutation>(UpdatePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePayment', 'mutation', variables);
    },
    saveInterBankTransferNativeDraft(variables: SaveInterBankTransferNativeDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveInterBankTransferNativeDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveInterBankTransferNativeDraftMutation>(SaveInterBankTransferNativeDraftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveInterBankTransferNativeDraft', 'mutation', variables);
    },
    saveIntraBankOwnerTransferDraft(variables: SaveIntraBankOwnerTransferDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveIntraBankOwnerTransferDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveIntraBankOwnerTransferDraftMutation>(SaveIntraBankOwnerTransferDraftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveIntraBankOwnerTransferDraft', 'mutation', variables);
    },
    saveCardTransfer(variables: SaveCardTransferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCardTransferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCardTransferMutation>(SaveCardTransferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveCardTransfer', 'mutation', variables);
    },
    saveIntraBankForeignTransferDraft(variables: SaveIntraBankForeignTransferDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveIntraBankForeignTransferDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveIntraBankForeignTransferDraftMutation>(SaveIntraBankForeignTransferDraftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveIntraBankForeignTransferDraft', 'mutation', variables);
    },
    saveConversionDraft(variables: SaveConversionDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveConversionDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveConversionDraftMutation>(SaveConversionDraftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveConversionDraft', 'mutation', variables);
    },
    saveSwift(variables: SaveSwiftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveSwiftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveSwiftMutation>(SaveSwiftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveSwift', 'mutation', variables);
    },
    signingPayment(variables: SigningPaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SigningPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SigningPaymentMutation>(SigningPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signingPayment', 'mutation', variables);
    },
    deletePayment(variables: DeletePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePaymentMutation>(DeletePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePayment', 'mutation', variables);
    },
    forSigningPayment(variables: ForSigningPaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForSigningPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForSigningPaymentMutation>(ForSigningPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'forSigningPayment', 'mutation', variables);
    },
    saveTransferTemplate(variables: SaveTransferTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveTransferTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveTransferTemplateMutation>(SaveTransferTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveTransferTemplate', 'mutation', variables);
    },
    updateTemplate(variables?: UpdateTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTemplateMutation>(UpdateTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTemplate', 'mutation', variables);
    },
    deleteTemplate(variables: DeleteTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTemplateMutation>(DeleteTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTemplate', 'mutation', variables);
    },
    recallPayment(variables: RecallPaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecallPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecallPaymentMutation>(RecallPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recallPayment', 'mutation', variables);
    },
    saveBudgetPayment(variables: SaveBudgetPaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveBudgetPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveBudgetPaymentMutation>(SaveBudgetPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveBudgetPayment', 'mutation', variables);
    },
    refundOperation(variables: RefundOperationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundOperationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundOperationMutation>(RefundOperationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundOperation', 'mutation', variables);
    },
    saveQrTransfer(variables: SaveQrTransferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveQrTransferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveQrTransferMutation>(SaveQrTransferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveQrTransfer', 'mutation', variables);
    },
    saveSalary(variables: SaveSalaryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveSalaryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveSalaryMutation>(SaveSalaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveSalary', 'mutation', variables);
    },
    signingSalary(variables: SigningSalaryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SigningSalaryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SigningSalaryMutation>(SigningSalaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signingSalary', 'mutation', variables);
    },
    getAllOperation(variables?: GetAllOperationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllOperationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllOperationQuery>(GetAllOperationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllOperation', 'query', variables);
    },
    getAllCountry(variables?: GetAllCountryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllCountryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllCountryQuery>(GetAllCountryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllCountry', 'query', variables);
    },
    getModelProcess(variables: GetModelProcessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetModelProcessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetModelProcessQuery>(GetModelProcessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getModelProcess', 'query', variables);
    },
    getBanksByCode(variables: GetBanksByCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBanksByCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBanksByCodeQuery>(GetBanksByCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBanksByCode', 'query', variables);
    },
    getBudgetClassificationsByCode(variables: GetBudgetClassificationsByCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBudgetClassificationsByCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBudgetClassificationsByCodeQuery>(GetBudgetClassificationsByCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBudgetClassificationsByCode', 'query', variables);
    },
    getOperationTypeCategoryByCode(variables: GetOperationTypeCategoryByCodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOperationTypeCategoryByCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOperationTypeCategoryByCodeQuery>(GetOperationTypeCategoryByCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOperationTypeCategoryByCode', 'query', variables);
    },
    searchPaymentByCriteria(variables: SearchPaymentByCriteriaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchPaymentByCriteriaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchPaymentByCriteriaQuery>(SearchPaymentByCriteriaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchPaymentByCriteria', 'query', variables);
    },
    findTransferDataByPaymentId(variables: FindTransferDataByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindTransferDataByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindTransferDataByPaymentIdQuery>(FindTransferDataByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findTransferDataByPaymentId', 'query', variables);
    },
    findConversionDataByPaymentId(variables: FindConversionDataByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindConversionDataByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindConversionDataByPaymentIdQuery>(FindConversionDataByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findConversionDataByPaymentId', 'query', variables);
    },
    findCardTransferDataByPaymentId(variables: FindCardTransferDataByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindCardTransferDataByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindCardTransferDataByPaymentIdQuery>(FindCardTransferDataByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findCardTransferDataByPaymentId', 'query', variables);
    },
    findRefundedQrOperationInfo(variables: FindRefundedQrOperationInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindRefundedQrOperationInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindRefundedQrOperationInfoQuery>(FindRefundedQrOperationInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findRefundedQrOperationInfo', 'query', variables);
    },
    findQrTransferDataByPaymentId(variables: FindQrTransferDataByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindQrTransferDataByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindQrTransferDataByPaymentIdQuery>(FindQrTransferDataByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findQrTransferDataByPaymentId', 'query', variables);
    },
    findBudgetPaymentDataByPaymentId(variables: FindBudgetPaymentDataByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindBudgetPaymentDataByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindBudgetPaymentDataByPaymentIdQuery>(FindBudgetPaymentDataByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findBudgetPaymentDataByPaymentId', 'query', variables);
    },
    calculateExoticAmountInSwift(variables: CalculateExoticAmountInSwiftQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalculateExoticAmountInSwiftQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalculateExoticAmountInSwiftQuery>(CalculateExoticAmountInSwiftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'calculateExoticAmountInSwift', 'query', variables);
    },
    findAllCurrency(variables?: FindAllCurrencyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllCurrencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllCurrencyQuery>(FindAllCurrencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllCurrency', 'query', variables);
    },
    findSwiftDataByPaymentId(variables: FindSwiftDataByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindSwiftDataByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSwiftDataByPaymentIdQuery>(FindSwiftDataByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findSwiftDataByPaymentId', 'query', variables);
    },
    getPaymentStatusHistoryByPaymentId(variables: GetPaymentStatusHistoryByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentStatusHistoryByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentStatusHistoryByPaymentIdQuery>(GetPaymentStatusHistoryByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentStatusHistoryByPaymentId', 'query', variables);
    },
    getPaymentSignerInfoByPaymentId(variables: GetPaymentSignerInfoByPaymentIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentSignerInfoByPaymentIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentSignerInfoByPaymentIdQuery>(GetPaymentSignerInfoByPaymentIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentSignerInfoByPaymentId', 'query', variables);
    },
    getTransferTemplateByCriteria(variables: GetTransferTemplateByCriteriaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTransferTemplateByCriteriaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTransferTemplateByCriteriaQuery>(GetTransferTemplateByCriteriaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTransferTemplateByCriteria', 'query', variables);
    },
    getSecondPersonTokenByPaymentIds(variables: GetSecondPersonTokenByPaymentIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSecondPersonTokenByPaymentIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSecondPersonTokenByPaymentIdsQuery>(GetSecondPersonTokenByPaymentIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSecondPersonTokenByPaymentIds', 'query', variables);
    },
    getInterBankOptions(variables?: GetInterBankOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetInterBankOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInterBankOptionsQuery>(GetInterBankOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInterBankOptions', 'query', variables);
    },
    getSwiftOptions(variables?: GetSwiftOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSwiftOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSwiftOptionsQuery>(GetSwiftOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSwiftOptions', 'query', variables);
    },
    getRepeatableTransferOptions(variables: GetRepeatableTransferOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRepeatableTransferOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRepeatableTransferOptionsQuery>(GetRepeatableTransferOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRepeatableTransferOptions', 'query', variables);
    },
    getRepeatableSwiftOptions(variables: GetRepeatableSwiftOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRepeatableSwiftOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRepeatableSwiftOptionsQuery>(GetRepeatableSwiftOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRepeatableSwiftOptions', 'query', variables);
    },
    getNumberOfPayment4Sign(variables: GetNumberOfPayment4SignQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetNumberOfPayment4SignQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNumberOfPayment4SignQuery>(GetNumberOfPayment4SignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getNumberOfPayment4Sign', 'query', variables);
    },
    getCurrencyRates(variables?: GetCurrencyRatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCurrencyRatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrencyRatesQuery>(GetCurrencyRatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCurrencyRates', 'query', variables);
    },
    getCurrencyRatesConversion(variables?: GetCurrencyRatesConversionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCurrencyRatesConversionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrencyRatesConversionQuery>(GetCurrencyRatesConversionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCurrencyRatesConversion', 'query', variables);
    },
    calculateCommission(variables: CalculateCommissionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalculateCommissionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalculateCommissionQuery>(CalculateCommissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'calculateCommission', 'query', variables);
    },
    checkIsRefundAvailable(variables: CheckIsRefundAvailableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckIsRefundAvailableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckIsRefundAvailableQuery>(CheckIsRefundAvailableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkIsRefundAvailable', 'query', variables);
    },
    getQrOperationHistory(variables: GetQrOperationHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetQrOperationHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetQrOperationHistoryQuery>(GetQrOperationHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getQrOperationHistory', 'query', variables);
    },
    getQrOperationsLast2Days(variables: GetQrOperationsLast2DaysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetQrOperationsLast2DaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetQrOperationsLast2DaysQuery>(GetQrOperationsLast2DaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getQrOperationsLast2Days', 'query', variables);
    },
    findAllQrTransferByFilter(variables: FindAllQrTransferByFilterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllQrTransferByFilterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllQrTransferByFilterQuery>(FindAllQrTransferByFilterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAllQrTransferByFilter', 'query', variables);
    },
    findSalaryDataByLegalPartyId(variables: FindSalaryDataByLegalPartyIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindSalaryDataByLegalPartyIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSalaryDataByLegalPartyIdQuery>(FindSalaryDataByLegalPartyIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findSalaryDataByLegalPartyId', 'query', variables);
    },
    findSalaryDetailBySalaryId(variables: FindSalaryDetailBySalaryIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindSalaryDetailBySalaryIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSalaryDetailBySalaryIdQuery>(FindSalaryDetailBySalaryIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findSalaryDetailBySalaryId', 'query', variables);
    },
    findSalaryDetailBySalaryIdForSign(variables: FindSalaryDetailBySalaryIdForSignQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindSalaryDetailBySalaryIdForSignQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindSalaryDetailBySalaryIdForSignQuery>(FindSalaryDetailBySalaryIdForSignDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findSalaryDetailBySalaryIdForSign', 'query', variables);
    },
    getQrOperationInstallment(variables: GetQrOperationInstallmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetQrOperationInstallmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetQrOperationInstallmentQuery>(GetQrOperationInstallmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getQrOperationInstallment', 'query', variables);
    },
    getTotalSumInstallment(variables: GetTotalSumInstallmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTotalSumInstallmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTotalSumInstallmentQuery>(GetTotalSumInstallmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTotalSumInstallment', 'query', variables);
    },
    getInvoiceStatusAmounts(variables: GetInvoiceStatusAmountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetInvoiceStatusAmountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvoiceStatusAmountsQuery>(GetInvoiceStatusAmountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInvoiceStatusAmounts', 'query', variables);
    },
    findPaymentsByInvoiceIds(variables: FindPaymentsByInvoiceIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindPaymentsByInvoiceIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindPaymentsByInvoiceIdsQuery>(FindPaymentsByInvoiceIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findPaymentsByInvoiceIds', 'query', variables);
    },
    findTransferByInvoiceDetailById(variables: FindTransferByInvoiceDetailByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindTransferByInvoiceDetailByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindTransferByInvoiceDetailByIdQuery>(FindTransferByInvoiceDetailByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findTransferByInvoiceDetailById', 'query', variables);
    },
    getPersonalQrOperationHistoryWithPagination(variables: GetPersonalQrOperationHistoryWithPaginationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPersonalQrOperationHistoryWithPaginationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPersonalQrOperationHistoryWithPaginationQuery>(GetPersonalQrOperationHistoryWithPaginationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPersonalQrOperationHistoryWithPagination', 'query', variables);
    },
    listenPayment(variables: ListenPaymentSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListenPaymentSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListenPaymentSubscription>(ListenPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listenPayment', 'subscription', variables);
    },
    listenSalary(variables: ListenSalarySubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListenSalarySubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListenSalarySubscription>(ListenSalaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listenSalary', 'subscription', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;